const arr =[
{
    "path":"/Operation",
    "name":"运",
    "component":"pages/operation/index",
    "redirect":null,
    "alwaysShow":false,
    "hidden":false,
    "sort":1,
    "id":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
    "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
    "meta":{
        "title":"运行管理系统",
        "icon":"iconyunhangguanli",
        "code":"",
        "portalIcon":null,
        "roles":[
        ]
    },
    "children":[
        {
            "path":"/Operation/Situation",
            "name":"",
            "component":"Layout",
            "redirect":null,
            "alwaysShow":false,
            "hidden":false,
            "sort":1,
            "id":"05c6a982-29a9-4c3c-b42d-55fe20a19d67",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"院校概况",
                "icon":"iconxueyuangaikuang",
                "code":"",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"/Operation/Situation/College",
                    "name":"CollegeInfo",
                    "component":"pages/operation/college/baseinfo/index",
                    "redirect":"",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":1,
                    "id":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                    "pid":"05c6a982-29a9-4c3c-b42d-55fe20a19d67",
                    "meta":{
                        "title":"学院基本信息",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListCollege",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"e61e64f1-e6f3-406e-a064-26ca60942685",
                            "pid":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"College",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewCollege",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"d766fcc5-d706-4165-af0a-8d97c03d9193",
                            "pid":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"College",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateCollege",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"a28d0618-b76e-436a-bab8-3f0557ca8be1",
                            "pid":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"College",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditCollege",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"a24b21a3-33d8-457b-9f5b-b697988cb391",
                            "pid":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"College",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteCollege",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"0c692df7-e569-41cc-b03d-33f76c93cd1d",
                            "pid":"6c25bd6d-609f-424f-9514-ba77f94855b4",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"College",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Situation/PersonnelTraining",
                    "name":"PersonnelTraining",
                    "component":"Layout",
                    "redirect":"/Operation/Situation/PersonnelTraining/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":2,
                    "id":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                    "pid":"05c6a982-29a9-4c3c-b42d-55fe20a19d67",
                    "meta":{
                        "title":"人才培养方针",
                        "icon":"",
                        "code":"PersonnelTraining",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListPersonnelTraining",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"17011bef-d57d-4289-bdd7-e14f181ce809",
                            "pid":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"PersonnelTraining",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewPersonnelTraining",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"d1bcee3d-b175-4469-802e-3a2d0ef3ec8e",
                            "pid":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"PersonnelTraining",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreatePersonnelTraining",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"aebbc3eb-09f5-47d6-9a50-7cbf6e4924d5",
                            "pid":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"PersonnelTraining",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditPersonnelTraining",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"352f8ba7-1770-44d7-8523-cf52fbdf87b8",
                            "pid":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"PersonnelTraining",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeletePersonnelTraining",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"b00a4b5b-ee1e-4320-b0dc-c56f06ee9ff5",
                            "pid":"9e04c3f7-20c2-426f-9dee-4c042f3674f1",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"PersonnelTraining",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Situation/Environment",
                    "name":"Environment",
                    "component":"Layout",
                    "redirect":"/Operation/Situation/Environment/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":3,
                    "id":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                    "pid":"05c6a982-29a9-4c3c-b42d-55fe20a19d67",
                    "meta":{
                        "title":"学院环境",
                        "icon":"",
                        "code":"Environment",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListEnvironment",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"ca62ceba-feec-44c0-b7cb-9871e8bf4f94",
                            "pid":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"Environment",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewEnvironment",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"94ebfa6d-bad9-4b7d-8bd0-3a10f838ad02",
                            "pid":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"Environment",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateEnvironment",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"63f85b2b-fb03-4e30-b839-4ad2cd47a82e",
                            "pid":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"Environment",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditEnvironment",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"af23c4da-bcac-4ac7-a9cd-2222cd69bbc3",
                            "pid":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"Environment",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteEnvironment",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"fbbc5430-e2a2-4606-b8ce-7c5db80a357a",
                            "pid":"f8c8a713-1ecb-4376-ab2c-731cb2d80c48",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"Environment",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Situation/PortalBanner",
                    "name":"PortalBanner",
                    "component":"Layout",
                    "redirect":"/Operation/Situation/PortalBanner/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":4,
                    "id":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                    "pid":"05c6a982-29a9-4c3c-b42d-55fe20a19d67",
                    "meta":{
                        "title":"横幅管理",
                        "icon":"",
                        "code":"PortalBanner",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListPortalBanner",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"100ca396-068a-43c6-ba36-7603d527a2f9",
                            "pid":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"PortalBanner",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewPortalBanner",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"449fcca6-a8cb-4691-9a4f-0b9998169a8c",
                            "pid":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"PortalBanner",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreatePortalBanner",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"e595ceb6-eae7-43ab-b40a-58b15093c5f6",
                            "pid":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"PortalBanner",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditPortalBanner",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"6912eba1-fe80-457e-95ab-22985accdbc8",
                            "pid":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"PortalBanner",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeletePortalBanner",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"09967f8d-47fc-4a7b-b827-32c435624e12",
                            "pid":"69e5e4bf-29b4-4efd-962a-45f1103bb3dc",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"PortalBanner",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "path":"/Operation/InformationPublish",
            "name":"InformationPublish",
            "component":"Layout",
            "redirect":null,
            "alwaysShow":false,
            "hidden":false,
            "sort":2,
            "id":"ef13e937-43c9-49e8-b895-c7e2310b78f3",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"信息发布",
                "icon":"iconxueyuandongtai",
                "code":"",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"/Operation/InformationPublish/Announcement",
                    "name":"Announcement",
                    "component":"Layout",
                    "redirect":"/Operation/InformationPublish/Announcement/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":1,
                    "id":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                    "pid":"ef13e937-43c9-49e8-b895-c7e2310b78f3",
                    "meta":{
                        "title":"通知公告",
                        "icon":"",
                        "code":"Announcement",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListAnnouncement",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"cbbb0a42-ff18-49f3-b113-6558f0a7644c",
                            "pid":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"Announcement",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewAnnouncement",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"fa06b3fa-8ba1-411a-a335-9effb935a710",
                            "pid":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"Announcement",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateAnnouncement",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"4b53dcb6-a060-4780-944d-c3881ed6d4d0",
                            "pid":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"Announcement",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditAnnouncement",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"ff81bce0-eba9-47f8-9a55-1f4d09030525",
                            "pid":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"Announcement",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteAnnouncement",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"041c5539-3871-4b95-ad32-1b452829fa8f",
                            "pid":"3da31b62-697c-4690-ae18-b60bd05b55b7",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"Announcement",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/InformationPublish/PolicySystem",
                    "name":"PolicySystem",
                    "component":"Layout",
                    "redirect":"/Operation/InformationPublish/PolicySystem/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":2,
                    "id":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                    "pid":"ef13e937-43c9-49e8-b895-c7e2310b78f3",
                    "meta":{
                        "title":"政策制度",
                        "icon":"",
                        "code":"PolicySystem",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListPolicySystem",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"9d1a59a3-9031-4c49-aef5-b6cdf9dcf195",
                            "pid":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"PolicySystem",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewPolicySystem",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"7f0789f2-be57-4c3f-8a10-dd673487c1b7",
                            "pid":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"PolicySystem",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreatePolicySystem",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"1df2f627-e50c-4007-8f76-42f0a5f57a46",
                            "pid":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"PolicySystem",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditPolicySystem",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"a58229c5-639d-46c5-b617-3b6e773836bd",
                            "pid":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"PolicySystem",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeletePolicySystem",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"462b7b53-2a53-4009-850e-fcf1899ea441",
                            "pid":"90e063de-68ab-4f8d-96af-edb1e7fc20aa",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"PolicySystem",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/InformationPublish/CollegeNews",
                    "name":"CollegeNews",
                    "component":"Layout",
                    "redirect":"/Operation/InformationPublish/CollegeNews/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":3,
                    "id":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                    "pid":"ef13e937-43c9-49e8-b895-c7e2310b78f3",
                    "meta":{
                        "title":"院校动态",
                        "icon":"",
                        "code":"CollegeNews",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListCollegeNews",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"b533e363-9fb0-40d0-84f2-d15fcff36f91",
                            "pid":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"CollegeNews",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewCollegeNews",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"074278af-a878-4f9c-a6e6-a30b28aab15a",
                            "pid":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"CollegeNews",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateCollegeNews",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"47715231-ccf1-4cec-95ee-97a6f9e7fbc0",
                            "pid":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"CollegeNews",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditCollegeNews",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"9780d8e5-68b3-40b3-b893-27a5f08bb9fa",
                            "pid":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"CollegeNews",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteCollegeNews",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"16880eb4-4019-4781-bcd4-15098f026969",
                            "pid":"64bb8d75-24c7-4c44-9f5a-828ea89efb76",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"CollegeNews",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "path":"/Operation/Major",
            "name":"Major",
            "component":"Layout",
            "redirect":"/Operation/Major/Index",
            "alwaysShow":false,
            "hidden":false,
            "sort":3,
            "id":"4f9ea33c-2fcc-43ef-ad9f-45e5f7801f65",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"专业信息",
                "icon":"iconzhuanyexinxi",
                "code":"",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"Index",
                    "name":"MajorManage",
                    "component":"pages/operation/major/index",
                    "redirect":"",
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":1,
                    "id":"06ae56d0-460d-4cdd-a87a-9ffcdc6e71a9",
                    "pid":"4f9ea33c-2fcc-43ef-ad9f-45e5f7801f65",
                    "meta":{
                        "title":"专业管理",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        },
        {
            "path":"/Operation/CollegeEnterpriseRelation",
            "name":"CollegeEnterpriseRelation",
            "component":"Layout",
            "redirect":"/Operation/CollegeEnterpriseRelation/List",
            "alwaysShow":false,
            "hidden":false,
            "sort":5,
            "id":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"合作企业",
                "icon":"iconhezuoqiye",
                "code":"CollegeEnterpriseRelation",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"List",
                    "name":"ListCollegeEnterpriseRelation",
                    "component":"pages/operation/enterprise-relation/list",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":1,
                    "id":"aaf46036-a515-4a83-9c68-88d2d77e2070",
                    "pid":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
                    "meta":{
                        "title":"列表",
                        "icon":null,
                        "code":"CollegeEnterpriseRelation",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"View",
                    "name":"ViewCollegeEnterpriseRelation",
                    "component":"pages/operation/enterprise-relation/view",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":2,
                    "id":"fed80fdc-c812-4bb8-9dcc-2114db9c418e",
                    "pid":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
                    "meta":{
                        "title":"详情",
                        "icon":null,
                        "code":"CollegeEnterpriseRelation",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Create",
                    "name":"CreateCollegeEnterpriseRelation",
                    "component":"pages/operation/enterprise-relation/create",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":3,
                    "id":"fb99a635-3730-4885-8437-bec6a47861fa",
                    "pid":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
                    "meta":{
                        "title":"添加",
                        "icon":null,
                        "code":"CollegeEnterpriseRelation",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Edit",
                    "name":"EditCollegeEnterpriseRelation",
                    "component":"pages/operation/enterprise-relation/edit",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":4,
                    "id":"a7372bad-5d74-4b62-ade4-298a996e0f5e",
                    "pid":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
                    "meta":{
                        "title":"修改",
                        "icon":null,
                        "code":"CollegeEnterpriseRelation",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Delete",
                    "name":"DeleteCollegeEnterpriseRelation",
                    "component":null,
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":5,
                    "id":"f191d94e-2d90-40f7-b76d-eaeb4c78c966",
                    "pid":"45e45e69-9817-4fc5-83ce-d16b5c98e64d",
                    "meta":{
                        "title":"删除",
                        "icon":null,
                        "code":"CollegeEnterpriseRelation",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        },
        {
            "path":"/Operation/Council",
            "name":"Council",
            "component":"Layout",
            "redirect":"/Operation/Council/List",
            "alwaysShow":false,
            "hidden":false,
            "sort":6,
            "id":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"理事会信息",
                "icon":"iconlishihuixinxi",
                "code":"Council",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"List",
                    "name":"ListCouncil",
                    "component":"views/content/data-set/index",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":1,
                    "id":"e50ad143-a657-435a-84a2-6c87d08126a3",
                    "pid":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
                    "meta":{
                        "title":"列表",
                        "icon":null,
                        "code":"Council",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"View",
                    "name":"ViewCouncil",
                    "component":"views/content/data-set/view",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":2,
                    "id":"8166b8db-83c0-45da-8b1f-3f4e5f04d578",
                    "pid":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
                    "meta":{
                        "title":"详情",
                        "icon":null,
                        "code":"Council",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Create",
                    "name":"CreateCouncil",
                    "component":"views/content/data-set/create",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":3,
                    "id":"16477bc5-f642-4673-80f7-cafd5887ec37",
                    "pid":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
                    "meta":{
                        "title":"添加",
                        "icon":null,
                        "code":"Council",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Edit",
                    "name":"EditCouncil",
                    "component":"views/content/data-set/edit",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":4,
                    "id":"93c1e4a2-d8cb-4ff2-b1f6-e9dcee4f316e",
                    "pid":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
                    "meta":{
                        "title":"修改",
                        "icon":null,
                        "code":"Council",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Delete",
                    "name":"DeleteCouncil",
                    "component":null,
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":5,
                    "id":"a9d37cdf-66d5-4043-bd83-1c4e858c0c27",
                    "pid":"b5f0a58c-f8a8-4e45-8ee6-d38ac45a576c",
                    "meta":{
                        "title":"删除",
                        "icon":null,
                        "code":"Council",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        },
        {
            "path":"/Operation/SchoolExpert",
            "name":"SchoolExpert",
            "component":"Layout",
            "redirect":"/Operation/SchoolExpert/List",
            "alwaysShow":false,
            "hidden":false,
            "sort":8,
            "id":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"院校专家",
                "icon":"iconshizituandui",
                "code":"SchoolExpert",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"List",
                    "name":"ListSchoolExpert",
                    "component":"views/content/data-set/index",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":1,
                    "id":"4ebefafb-2c59-46a6-ba91-b7ea85868cbb",
                    "pid":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
                    "meta":{
                        "title":"列表",
                        "icon":null,
                        "code":"SchoolExpert",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"View",
                    "name":"ViewSchoolExpert",
                    "component":"views/content/data-set/view",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":2,
                    "id":"b96e9fc6-2f1d-4220-9bec-0216e15b98ab",
                    "pid":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
                    "meta":{
                        "title":"详情",
                        "icon":null,
                        "code":"SchoolExpert",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Create",
                    "name":"CreateSchoolExpert",
                    "component":"views/content/data-set/create",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":3,
                    "id":"ee6bf691-62b5-417b-b518-bd85abed3539",
                    "pid":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
                    "meta":{
                        "title":"添加",
                        "icon":null,
                        "code":"SchoolExpert",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Edit",
                    "name":"EditSchoolExpert",
                    "component":"views/content/data-set/edit",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":4,
                    "id":"91461c3e-a048-4c77-ad19-cabebd0ca73d",
                    "pid":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
                    "meta":{
                        "title":"修改",
                        "icon":null,
                        "code":"SchoolExpert",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Delete",
                    "name":"DeleteSchoolExpert",
                    "component":null,
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":5,
                    "id":"5832256c-f203-4284-98e6-18ba7b538a7d",
                    "pid":"af7f4d37-83ea-4d08-9561-733f0efe8f62",
                    "meta":{
                        "title":"删除",
                        "icon":null,
                        "code":"SchoolExpert",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        },
        {
            "path":"/Operation/TestDemo",
            "name":"TestDemo",
            "component":"Layout",
            "redirect":"/Operation/TestDemo/List",
            "alwaysShow":false,
            "hidden":false,
            "sort":9,
            "id":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"内容管理测试",
                "icon":"iconxueyuandongtai",
                "code":"TestDemo",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"List",
                    "name":"ListTestDemo",
                    "component":"views/content/data-set/index",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":1,
                    "id":"00b8b022-0860-476b-8e72-b96781c691a3",
                    "pid":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
                    "meta":{
                        "title":"列表",
                        "icon":null,
                        "code":"TestDemo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"View",
                    "name":"ViewTestDemo",
                    "component":"views/content/data-set/view",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":2,
                    "id":"1eb79e96-6726-4155-ad30-2ecc64030daa",
                    "pid":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
                    "meta":{
                        "title":"详情",
                        "icon":null,
                        "code":"TestDemo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Create",
                    "name":"CreateTestDemo",
                    "component":"views/content/data-set/create",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":3,
                    "id":"8d6d5d2d-1de4-4fcd-bb7c-ff42d4be61c0",
                    "pid":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
                    "meta":{
                        "title":"添加",
                        "icon":null,
                        "code":"TestDemo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Edit",
                    "name":"EditTestDemo",
                    "component":"views/content/data-set/edit",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":4,
                    "id":"1e629c6b-ce13-46c2-961b-866af4a5e200",
                    "pid":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
                    "meta":{
                        "title":"修改",
                        "icon":null,
                        "code":"TestDemo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"Delete",
                    "name":"DeleteTestDemo",
                    "component":null,
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":5,
                    "id":"3e802719-1ce7-4c0a-9453-563b2771d34f",
                    "pid":"9c1ccdcd-1221-49e6-b016-0894b435d9d7",
                    "meta":{
                        "title":"删除",
                        "icon":null,
                        "code":"TestDemo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        },
        {
            "path":"/Operation/Enroll",
            "name":"OperationEnroll",
            "component":"Layout",
            "redirect":null,
            "alwaysShow":false,
            "hidden":false,
            "sort":15,
            "id":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"招生平台",
                "icon":"iconzhaoshengpingtai",
                "code":"",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"/Operation/Enroll/SchoolRecruitmentPlan",
                    "name":"SchoolRecruitmentPlan",
                    "component":"Layout",
                    "redirect":"/Operation/Enroll/SchoolRecruitmentPlan/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":1,
                    "id":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                    "pid":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
                    "meta":{
                        "title":"招生计划",
                        "icon":"",
                        "code":"SchoolRecruitmentPlan",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListSchoolRecruitmentPlan",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"8da418f2-4f4d-4848-87a1-8a11f774e966",
                            "pid":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"SchoolRecruitmentPlan",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewSchoolRecruitmentPlan",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"ee64dd3f-d196-457f-9422-67f7498b6bbe",
                            "pid":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"SchoolRecruitmentPlan",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateSchoolRecruitmentPlan",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"c3d9e33e-a24f-49e6-bf6f-16a7f5975ceb",
                            "pid":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"SchoolRecruitmentPlan",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditSchoolRecruitmentPlan",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"d921871f-8257-449b-9033-8eb561258e4c",
                            "pid":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"SchoolRecruitmentPlan",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteSchoolRecruitmentPlan",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"6489cef6-23f1-472d-892a-b5c8b2183c3e",
                            "pid":"00152bc2-17dc-4d3a-ac40-dd19fa72c8ec",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"SchoolRecruitmentPlan",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Enroll/SchoolEnrollmentBrochure",
                    "name":"SchoolEnrollmentBrochure",
                    "component":"Layout",
                    "redirect":"/Operation/Enroll/SchoolEnrollmentBrochure/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":2,
                    "id":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                    "pid":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
                    "meta":{
                        "title":"招生简章",
                        "icon":"",
                        "code":"SchoolEnrollmentBrochure",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListSchoolEnrollmentBrochure",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"612d2691-6adf-4c76-866d-fadafc77bf00",
                            "pid":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"SchoolEnrollmentBrochure",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewSchoolEnrollmentBrochure",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"947245ba-1b87-485f-96f7-8cee8e6c294b",
                            "pid":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"SchoolEnrollmentBrochure",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateSchoolEnrollmentBrochure",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"b90e3bb9-be3e-4117-98af-3a81fbc3b05c",
                            "pid":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"SchoolEnrollmentBrochure",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditSchoolEnrollmentBrochure",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"2bc09d6e-ff6c-4846-ba5f-6b6627048b85",
                            "pid":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"SchoolEnrollmentBrochure",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteSchoolEnrollmentBrochure",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"98144dec-7917-41be-a0e9-ca53fed9a161",
                            "pid":"9bd02623-215c-43e5-8dab-27ec6687f94b",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"SchoolEnrollmentBrochure",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Enroll/RegisterSchool",
                    "name":"RegisterSchool",
                    "component":"Layout",
                    "redirect":"/Operation/Enroll/RegisterSchool/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":3,
                    "id":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                    "pid":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
                    "meta":{
                        "title":"预报名",
                        "icon":"",
                        "code":"RegisterSchool",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListRegisterSchool",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"6e901c71-4b89-4784-86fb-5afd667b187d",
                            "pid":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"RegisterSchool",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewRegisterSchool",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"567ec250-c126-4047-9155-b74805997974",
                            "pid":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"RegisterSchool",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateRegisterSchool",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"42e7bb81-d737-4a32-9975-4291ac43f0cd",
                            "pid":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"RegisterSchool",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditRegisterSchool",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"1235c5fe-add6-4c31-aa92-7ceb7d4d1831",
                            "pid":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"RegisterSchool",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteRegisterSchool",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"d7a58686-85aa-443f-b524-f7d6cd450c16",
                            "pid":"cd6a03b0-28d6-4737-b482-dec822fa0f92",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"RegisterSchool",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Enroll/SchoolAdmissionInfo",
                    "name":"SchoolAdmissionInfo",
                    "component":"Layout",
                    "redirect":"/Operation/Enroll/SchoolAdmissionInfo/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":4,
                    "id":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                    "pid":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
                    "meta":{
                        "title":"录取信息",
                        "icon":"",
                        "code":"SchoolAdmissionInfo",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListSchoolAdmissionInfo",
                            "component":"views/content/data-set/index",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"9215f4af-3101-4243-8669-e5687514cd9a",
                            "pid":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"SchoolAdmissionInfo",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewSchoolAdmissionInfo",
                            "component":"views/content/data-set/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"37884529-2eb5-4e93-ac15-3126d3c1b3da",
                            "pid":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"SchoolAdmissionInfo",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateSchoolAdmissionInfo",
                            "component":"views/content/data-set/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"780dc9ea-c8cf-47ee-97be-c63d69fbbc47",
                            "pid":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"SchoolAdmissionInfo",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditSchoolAdmissionInfo",
                            "component":"views/content/data-set/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"ee9cff78-ce20-42ba-bbf3-b7a1851feb1c",
                            "pid":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"SchoolAdmissionInfo",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteSchoolAdmissionInfo",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"0af9fbbb-7399-49e1-9b9c-6a51bfad6905",
                            "pid":"db54bc4e-611d-4aa7-bc53-2845cfee6159",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"SchoolAdmissionInfo",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                },
                {
                    "path":"/Operation/Enroll/EnrollmentStatistics/EnrollmentStatistics",
                    "name":"EnrollmentStatistics",
                    "component":"Layout",
                    "redirect":"/Operation/Enroll/EnrollmentStatistics/EnrollmentStatistics/List",
                    "alwaysShow":false,
                    "hidden":false,
                    "sort":5,
                    "id":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                    "pid":"5d2f8d40-3453-4d1a-a9c1-f1f6c3e1b695",
                    "meta":{
                        "title":"招生就业统计",
                        "icon":"",
                        "code":"EnrollmentStatistics",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                        {
                            "path":"List",
                            "name":"ListEnrollmentStatistics",
                            "component":"pages/operation/enrollmentstatistics/list",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":1,
                            "id":"897fb969-eeb0-46ad-9346-522bc187a058",
                            "pid":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                            "meta":{
                                "title":"列表",
                                "icon":null,
                                "code":"EnrollmentStatistics",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"View",
                            "name":"ViewEnrollmentStatistics",
                            "component":"pages/operation/enrollmentstatistics/view",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":2,
                            "id":"73c164e8-f2f2-4c3a-92d8-f8cde0daa58b",
                            "pid":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                            "meta":{
                                "title":"详情",
                                "icon":null,
                                "code":"EnrollmentStatistics",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Create",
                            "name":"CreateEnrollmentStatistics",
                            "component":"pages/operation/enrollmentstatistics/create",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":3,
                            "id":"387ee8c4-65e6-4a13-947b-2c03a7d6d302",
                            "pid":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                            "meta":{
                                "title":"添加",
                                "icon":null,
                                "code":"EnrollmentStatistics",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Edit",
                            "name":"EditEnrollmentStatistics",
                            "component":"pages/operation/enrollmentstatistics/edit",
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":4,
                            "id":"6019b768-f86c-4e75-b4ba-3aeeb888db39",
                            "pid":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                            "meta":{
                                "title":"修改",
                                "icon":null,
                                "code":"EnrollmentStatistics",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        },
                        {
                            "path":"Delete",
                            "name":"DeleteEnrollmentStatistics",
                            "component":null,
                            "redirect":null,
                            "alwaysShow":false,
                            "hidden":true,
                            "sort":5,
                            "id":"7dd1b5c7-3c0e-4bb1-803e-cc6ca2c7ba49",
                            "pid":"eac66e60-1498-4926-acc8-7a4c03c5b9a6",
                            "meta":{
                                "title":"删除",
                                "icon":null,
                                "code":"EnrollmentStatistics",
                                "portalIcon":null,
                                "roles":[
                                ]
                            },
                            "children":[
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "path":"/Operation/PilotMaterialSubmit",
            "name":"OperationPilotMaterialSubmit",
            "component":"Layout",
            "redirect":"/Operation/PilotMaterialSubmit/SubmitList",
            "alwaysShow":false,
            "hidden":false,
            "sort":18,
            "id":"7286e844-aca3-4920-877c-4ce6e3a73d9f",
            "pid":"f47fdcb4-1ebe-4736-9eb5-01513817ccd6",
            "meta":{
                "title":"试点建设材料",
                "icon":"iconjihuanengli",
                "code":"",
                "portalIcon":null,
                "roles":[
                ]
            },
            "children":[
                {
                    "path":"SubmitList",
                    "name":"SubmitListMaterial",
                    "component":"pages/operation/pilot-material/submit/list",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":11,
                    "id":"61ec4e05-0df0-486d-af72-ab83c86e08e3",
                    "pid":"7286e844-aca3-4920-877c-4ce6e3a73d9f",
                    "meta":{
                        "title":"材料列表",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"SubmitDetail",
                    "name":"SubmitDetailMaterial",
                    "component":"pages/operation/pilot-material/submit/detail",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":12,
                    "id":"b430c6b7-0237-4f71-bc1f-266575ebd358",
                    "pid":"7286e844-aca3-4920-877c-4ce6e3a73d9f",
                    "meta":{
                        "title":"材料详情",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"SubmitMaterial",
                    "name":"SubmitMaterial",
                    "component":"pages/operation/pilot-material/submit/submit",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":13,
                    "id":"1c0541e6-7c3f-421d-9050-f44afbeec215",
                    "pid":"7286e844-aca3-4920-877c-4ce6e3a73d9f",
                    "meta":{
                        "title":"材料提交",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                },
                {
                    "path":"SubmitView",
                    "name":"SubmitViewMaterial",
                    "component":"pages/operation/pilot-material/view",
                    "redirect":null,
                    "alwaysShow":false,
                    "hidden":true,
                    "sort":14,
                    "id":"d3645f24-9c05-4f31-8913-a0247aed2c5d",
                    "pid":"7286e844-aca3-4920-877c-4ce6e3a73d9f",
                    "meta":{
                        "title":"材料查看",
                        "icon":"",
                        "code":"",
                        "portalIcon":null,
                        "roles":[
                        ]
                    },
                    "children":[
                    ]
                }
            ]
        }
    ]
},
{
      "path":"/Production",
      "name":"产",
      "component":"pages/production/index",
      "redirect":null,
      "alwaysShow":false,
      "hidden":false,
      "sort":2,
      "id":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
      "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
      "meta":{
          "title":"生产实践管理系统",
          "icon":"iconshengchanguanli",
          "code":"",
          "portalIcon":null,
          "roles":[

          ]
      },
      "children":[
          {
              "path":"/Production/Recruit",
              "name":"ProductionRecruit",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":1,
              "id":"97e93053-276c-4d13-8c86-21d1eecf5a8b",
              "pid":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
              "meta":{
                  "title":"招工系统",
                  "icon":"iconzhuanjiafuwu",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Production/Recruit/SpecialJobFair",
                      "name":"SpecialJobFair",
                      "component":"Layout",
                      "redirect":"/Production/Recruit/SpecialJobFair/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":6,
                      "id":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                      "pid":"97e93053-276c-4d13-8c86-21d1eecf5a8b",
                      "meta":{
                          "title":"专场招聘会",
                          "icon":"",
                          "code":"SpecialJobFair",
                          "portalIcon":"iconzhuanchangzhaopinhui-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListSpecialJobFair",
                              "component":"pages/production/recruit/special-job-fair/list",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"6245c806-2da7-47c3-8752-862838e43e72",
                              "pid":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"SpecialJobFair",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewSpecialJobFair",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"e1e5dd32-596e-4f7b-972f-2914831713c8",
                              "pid":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"SpecialJobFair",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateSpecialJobFair",
                              "component":"pages/production/recruit/special-job-fair/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"d7c5fecd-42ab-4b63-b92f-648d0a2c0cfb",
                              "pid":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"SpecialJobFair",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditSpecialJobFair",
                              "component":"pages/production/recruit/special-job-fair/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"c12adeba-7136-4611-bd65-8c5e182989a6",
                              "pid":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"SpecialJobFair",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteSpecialJobFair",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"be58b31a-ea86-48a7-bd34-be917b8df7fd",
                              "pid":"ee21b50e-39d3-4187-8dec-adf0662b346a",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"SpecialJobFair",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Production/Recruit/preach/",
                      "name":"Preach",
                      "component":"Layout",
                      "redirect":"/Production/Recruit/preach/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":10,
                      "id":"098a3539-d7d3-4d2d-a42d-024acc787506",
                      "pid":"97e93053-276c-4d13-8c86-21d1eecf5a8b",
                      "meta":{
                          "title":"线上宣讲会",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconxianshangxuanjianghui-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"PreachList",
                              "component":"pages/production/recruit/preach/index",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"3f81ea0a-c8b5-4bb1-897a-48e85490c1b8",
                              "pid":"098a3539-d7d3-4d2d-a42d-024acc787506",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view",
                              "name":"PreachView",
                              "component":"pages/production/recruit/preach/view",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"ab3ec11b-8ff5-4b1f-9f0b-8d6d6c8d87b8",
                              "pid":"098a3539-d7d3-4d2d-a42d-024acc787506",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"PreachCreate",
                              "component":"pages/production/recruit/preach/create",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"41583029-1453-4ee5-ab88-6da73d976a27",
                              "pid":"098a3539-d7d3-4d2d-a42d-024acc787506",
                              "meta":{
                                  "title":"添加",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit",
                              "name":"PreachEdit",
                              "component":"pages/production/recruit/preach/edit",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"66dee76e-cece-4dbc-a553-8d162a5b7446",
                              "pid":"098a3539-d7d3-4d2d-a42d-024acc787506",
                              "meta":{
                                  "title":"修改",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Production/Recruit/RecruitNews",
                      "name":"RecruitNews",
                      "component":"Layout",
                      "redirect":"/Production/Recruit/RecruitNews/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":12,
                      "id":"d6b045fd-32c7-4956-8448-1194c5da761e",
                      "pid":"97e93053-276c-4d13-8c86-21d1eecf5a8b",
                      "meta":{
                          "title":"企业招工新闻",
                          "icon":"",
                          "code":"RecruitNews",
                          "portalIcon":"iconxinwen",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListRecruitNews",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7a33d200-edf4-42c0-8eef-df48331241c0",
                              "pid":"d6b045fd-32c7-4956-8448-1194c5da761e",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"RecruitNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewRecruitNews",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"b11cb3de-4002-4692-93de-7631c662487a",
                              "pid":"d6b045fd-32c7-4956-8448-1194c5da761e",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"RecruitNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateRecruitNews",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"d726e5d5-3765-4556-9cad-40e3b98cef8e",
                              "pid":"d6b045fd-32c7-4956-8448-1194c5da761e",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"RecruitNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditRecruitNews",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"92a1ee12-74ec-4033-8b1a-be4c95a9d204",
                              "pid":"d6b045fd-32c7-4956-8448-1194c5da761e",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"RecruitNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteRecruitNews",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"dcc995fb-da80-4aeb-8ea5-8f0df0b7e1d0",
                              "pid":"d6b045fd-32c7-4956-8448-1194c5da761e",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"RecruitNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Production/practice-base",
              "name":"PracticeBase",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":2,
              "id":"de839619-2855-4d34-b889-9442ac3f9959",
              "pid":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
              "meta":{
                  "title":"实践基地",
                  "icon":"iconlianmengguanli",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/production/practice-base/base-manage",
                      "name":"BaseManage",
                      "component":"Layout",
                      "redirect":"/production/practice-base/base-manage/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                      "pid":"de839619-2855-4d34-b889-9442ac3f9959",
                      "meta":{
                          "title":"基地管理",
                          "icon":"",
                          "code":"PracticeBase",
                          "portalIcon":"iconjidiguanli-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"BaseManageList",
                              "component":"pages/production/practice-base/base-manage/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"48efcee2-7513-406d-8257-7f685bbe0971",
                              "pid":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"PracticeBase",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"BaseManageView",
                              "component":"pages/production/practice-base/base-manage/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"504c6bf3-c84c-4e32-b2a8-b623976bb3dd",
                              "pid":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"PracticeBase",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"BaseManageCreate",
                              "component":"pages/production/practice-base/base-manage/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"cf0cf61a-d866-41b9-a26a-b37e3dafddf5",
                              "pid":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"PracticeBase",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit/:id",
                              "name":"BaseManageEdit",
                              "component":"pages/production/practice-base/base-manage/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"084bee5f-3433-440c-903b-117f93b0be5a",
                              "pid":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"PracticeBase",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"delete",
                              "name":"BaseManageDelete",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"464c166f-668d-4c5d-bccd-68143750fae5",
                              "pid":"cabb35dc-3a7a-4ac2-86f4-0431d1c7bc49",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"PracticeBase",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/practice-base/base-rule",
                      "name":"PracticeBaseRule",
                      "component":"Layout",
                      "redirect":"/production/practice-base/base-rule/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"10dda089-21c5-4dd6-b8b9-52086c98c0cf",
                      "pid":"de839619-2855-4d34-b889-9442ac3f9959",
                      "meta":{
                          "title":"基地规则",
                          "icon":"",
                          "code":"",
                          "portalIcon":"icongongshitianbao",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"PracticeBaseRuleList",
                              "component":"pages/production/practice-base/base-rule/index",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"34f5cfa4-125d-4237-b7a7-c2a7fcdeaa4a",
                              "pid":"10dda089-21c5-4dd6-b8b9-52086c98c0cf",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"PracticeBaseRuleAdd",
                              "component":"pages/production/practice-base/base-rule/create",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"0bade29c-c627-4faf-bd94-44d395788efb",
                              "pid":"10dda089-21c5-4dd6-b8b9-52086c98c0cf",
                              "meta":{
                                  "title":"新增",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"PracticeBaseRuleView",
                              "component":"pages/production/practice-base/base-rule/view",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"de018869-8fe2-49db-85ba-db0f0114a559",
                              "pid":"10dda089-21c5-4dd6-b8b9-52086c98c0cf",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"delete",
                              "name":"PracticeBaseRuleDelete",
                              "component":"",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"78d54f25-1c5c-4016-be9d-2b197322e706",
                              "pid":"10dda089-21c5-4dd6-b8b9-52086c98c0cf",
                              "meta":{
                                  "title":"删除",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/practice-base/base-arrange",
                      "name":"BaseArrange",
                      "component":"Layout",
                      "redirect":"/production/practice-base/base-arrange/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"dbc3bc41-97a6-422c-b6e5-067526cf6ab7",
                      "pid":"de839619-2855-4d34-b889-9442ac3f9959",
                      "meta":{
                          "title":"基地编排",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjidibianpai-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"BaseArrangeList",
                              "component":"pages/production/practice-base/base-arrange/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"b4215995-db9a-4c06-b75d-d786c57afe44",
                              "pid":"dbc3bc41-97a6-422c-b6e5-067526cf6ab7",
                              "meta":{
                                  "title":"编排列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"smart",
                              "name":"BaseManageArrangeSmart",
                              "component":"pages/production/practice-base/base-arrange/smart",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"080d001a-987f-41af-a521-26bbb8ebb6d7",
                              "pid":"dbc3bc41-97a6-422c-b6e5-067526cf6ab7",
                              "meta":{
                                  "title":"智能编排",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"manual",
                              "name":"BaseManageArrangeManual",
                              "component":"pages/production/practice-base/base-arrange/manual",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"e73d2cf6-253b-4d1d-baa3-f8051cc7f790",
                              "pid":"dbc3bc41-97a6-422c-b6e5-067526cf6ab7",
                              "meta":{
                                  "title":"手动编排",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"delete",
                              "name":"BaseArrangeDelete",
                              "component":"",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"0bda3776-1064-4984-ac89-cfa46eccb424",
                              "pid":"dbc3bc41-97a6-422c-b6e5-067526cf6ab7",
                              "meta":{
                                  "title":"删除",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/practice-base/base-apply",
                      "name":"BaseApply",
                      "component":"Layout",
                      "redirect":"/production/practice-base/base-apply/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"24e3227b-b012-42a0-be29-5da270a1b5a1",
                      "pid":"de839619-2855-4d34-b889-9442ac3f9959",
                      "meta":{
                          "title":"基地申请",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjidishenqing-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"BaseApplyList",
                              "component":"pages/production/practice-base/base-apply/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"e845f604-92ef-4795-8fe0-9cd938c467fd",
                              "pid":"24e3227b-b012-42a0-be29-5da270a1b5a1",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"approve/:id",
                              "name":"BaseApplyApprove",
                              "component":"pages/production/practice-base/base-apply/approve",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"2ee657de-f018-444f-a0cf-6b3e1cb392ed",
                              "pid":"24e3227b-b012-42a0-be29-5da270a1b5a1",
                              "meta":{
                                  "title":"审批",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"BaseApplyCreate",
                              "component":"pages/production/practice-base/base-apply/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"8345ceca-95c4-4da2-81a7-4c048d7fdebd",
                              "pid":"24e3227b-b012-42a0-be29-5da270a1b5a1",
                              "meta":{
                                  "title":"申请",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"BaseApplyView",
                              "component":"pages/production/practice-base/base-apply/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"1d561108-ccfd-4c90-a356-aae41b08cdde",
                              "pid":"24e3227b-b012-42a0-be29-5da270a1b5a1",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/practice-base/statistics",
                      "name":"BaseStatistics",
                      "component":"pages/production/practice-base/base-statistics/index",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"d22484ce-125c-49a4-92e5-9ed566a9da68",
                      "pid":"de839619-2855-4d34-b889-9442ac3f9959",
                      "meta":{
                          "title":"使用分析",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjidishiyongqingkuang-big",
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/production/internship-enterprise",
              "name":"InternshipEnterprise",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":3,
              "id":"24c54e02-b582-41b4-b8a7-e7ccc20930fa",
              "pid":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
              "meta":{
                  "title":"企业实习",
                  "icon":"iconwallet",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/production/internship-enterprise/internship-plan/",
                      "name":"InternshipPlan",
                      "component":"Layout",
                      "redirect":"/production/internship-enterprise/internship-plan/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                      "pid":"24c54e02-b582-41b4-b8a7-e7ccc20930fa",
                      "meta":{
                          "title":"实习计划",
                          "icon":"",
                          "code":"InternshipPlan",
                          "portalIcon":"iconshixijihua-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"ListInternshipPlan",
                              "component":"pages/production/internship-enterprise/internship-plan/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"f5c46edc-176e-40c6-ab33-9ba587fe9d27",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"InternshipPlan",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"ViewInternshipPlan",
                              "component":"pages/production/internship-enterprise/internship-plan/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"dc0c79d7-4af0-4fd7-93ca-18ddeb2b2f8f",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"InternshipPlan",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"CreateInternshipPlan",
                              "component":"pages/production/internship-enterprise/internship-plan/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"f24d4307-b9d5-4cd7-a134-2b31a83bd28a",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"InternshipPlan",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit/:id",
                              "name":"EditInternshipPlan",
                              "component":"pages/production/internship-enterprise/internship-plan/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"1ab7ace2-fba0-4fef-bc48-15510917b254",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"InternshipPlan",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"delete",
                              "name":"DeleteInternshipPlan",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"45be7bcc-e9b4-4f83-b276-00b587f46926",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"InternshipPlan",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"post/:id",
                              "name":"InternshipPostList",
                              "component":"pages/production/internship-enterprise/internship-plan/post",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":6,
                              "id":"8d9a82ff-9ded-499f-a619-381dd5c47526",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"岗位计划",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"units/:id",
                              "name":"InternshipUnits",
                              "component":"pages/production/internship-enterprise/internship-units/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":7,
                              "id":"fbe2d304-005b-4afb-93a8-77fc6387bc66",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"实习企业",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"units-create",
                              "name":"InternshipUnitsCreate",
                              "component":"pages/production/internship-enterprise/internship-units/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":8,
                              "id":"05ee9f14-bf40-4869-bd11-70b738846a18",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"添加企业",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"units-edit/:id",
                              "name":"InternshipUnitsEdit",
                              "component":"pages/production/internship-enterprise/internship-units/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":9,
                              "id":"1076f534-02b0-440c-9b6c-c892d52c723f",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"修改企业",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"units-view/:id",
                              "name":"InternshipUnitsView",
                              "component":"pages/production/internship-enterprise/internship-units/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":10,
                              "id":"1f4f0231-7e2a-4d3e-8370-1ace5d77ad8d",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"企业详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"units-delete",
                              "name":"InternshipUnitsDelete",
                              "component":"",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":11,
                              "id":"5ab25e02-9156-4d5b-a7fe-16b4e03ab85b",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"删除企业",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"job/:id",
                              "name":"InternshipUnitsJob",
                              "component":"pages/production/internship-enterprise/internship-job/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":12,
                              "id":"8b0f1f5b-42e5-4571-a2e2-c5ce54889b22",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"实习岗位",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"job-create",
                              "name":"InternshipUnitsJobCreate",
                              "component":"pages/production/internship-enterprise/internship-job/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":13,
                              "id":"aeeefb1a-6864-4274-b721-cf3d270a9334",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"添加岗位",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"job-view/:id",
                              "name":"InternshipUnitsJobView",
                              "component":"pages/production/internship-enterprise/internship-job/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":14,
                              "id":"5aa6a165-af4c-45bb-9fcc-c40c07c1d808",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"岗位详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"job-edit/:id",
                              "name":"InternshipUnitsJobEdit",
                              "component":"pages/production/internship-enterprise/internship-job/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":15,
                              "id":"f27d077b-1092-4805-bf89-bb14caf62dfc",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"修改岗位",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"job-delete",
                              "name":"InternshipUnitsJobDelete",
                              "component":"",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":16,
                              "id":"346efc69-ea37-4f5d-aab6-fb4ad07be954",
                              "pid":"f85ca6c5-901a-4723-a54d-4b8fa9d45ad3",
                              "meta":{
                                  "title":"删除岗位",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/internship-enterprise/intership-implementation",
                      "name":"InternshipImplementation",
                      "component":"Layout",
                      "redirect":"/production/internship-enterprise/intership-implementation/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                      "pid":"24c54e02-b582-41b4-b8a7-e7ccc20930fa",
                      "meta":{
                          "title":"实习实施",
                          "icon":"",
                          "code":"Internship",
                          "portalIcon":"iconshixijihua-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"ListInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"1b6f56b9-a730-4485-8ea2-20d7fac9f0a9",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Internship",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"import",
                              "name":"ImportInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/importStudent",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"8c0cdff4-efb1-49a5-9257-05a48065b9b5",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"批量导入",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"CreateInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"b5ab52e5-a92d-4a92-b58d-61d013700023",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"批量添加",
                                  "icon":null,
                                  "code":"Internship",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"tracking-list/:id",
                              "name":"TrackingInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/trackingList",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"726cb1d5-56ce-4e3e-b7cf-c30f32bda1d3",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"就业跟踪列表(已废弃)",
                                  "icon":null,
                                  "code":"Internship",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"tracking-view/:id",
                              "name":"TrackingInternshipView",
                              "component":"pages/production/internship-enterprise/intership-implementation/trackingView",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"68cf40e8-98fc-4d4c-985d-f84cfe19a0ba",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"就业跟踪",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"attendance-record/:id",
                              "name":"AttendanceRecordInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/attendanceRecord",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":6,
                              "id":"a5990c66-11fe-4395-923f-e5f12057f7a3",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"考勤数据",
                                  "icon":null,
                                  "code":"Internship",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"journal/:id",
                              "name":"JournalInternship",
                              "component":"pages/production/internship-enterprise/intership-implementation/journal",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":7,
                              "id":"cb867a7d-7003-455c-b9e0-d3a4286e1497",
                              "pid":"1ef72ae0-f986-4ac3-9aa5-abcb95ce95b6",
                              "meta":{
                                  "title":"实习日志",
                                  "icon":null,
                                  "code":"Internship",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/internship-enterprise/transfer-apply",
                      "name":"TransferApply",
                      "component":"Layout",
                      "redirect":"/production/internship-enterprise/transfer-apply/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"6ca154fd-7cd8-47b7-a2bc-88a388e5ab1e",
                      "pid":"24c54e02-b582-41b4-b8a7-e7ccc20930fa",
                      "meta":{
                          "title":"转岗审批",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjiankongzhongxin",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"TransferApplyList",
                              "component":"pages/production/internship-enterprise/transfer-apply/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"68bc7fd9-f0df-4e2c-a927-2068b5bc934a",
                              "pid":"6ca154fd-7cd8-47b7-a2bc-88a388e5ab1e",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"apply/:id",
                              "name":"TransferApplyPost",
                              "component":"pages/production/internship-enterprise/transfer-apply/apply",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"df8670dd-e93e-400c-93ca-610b39f67eb5",
                              "pid":"6ca154fd-7cd8-47b7-a2bc-88a388e5ab1e",
                              "meta":{
                                  "title":"审批(已废弃)",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/production/internship-report",
              "name":"InternshipReport",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":4,
              "id":"f313c949-d19a-46f2-8dff-979c56f8e5d0",
              "pid":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
              "meta":{
                  "title":"过程记录",
                  "icon":"iconviewlist",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/production/internship-report/daily-list",
                      "name":"DailyVeiw",
                      "component":"Layout",
                      "redirect":"/production/internship-report/daily-list/view",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"929e6ad5-6b4e-4da4-9a2e-1048c9dc28e6",
                      "pid":"f313c949-d19a-46f2-8dff-979c56f8e5d0",
                      "meta":{
                          "title":"生产日报",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconiconribao-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"view",
                              "name":"DailySearchView",
                              "component":"pages/production/internship-report/daily-manage/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7ddfbb48-fa54-4d51-bdb6-9d3aead13a2e",
                              "pid":"929e6ad5-6b4e-4da4-9a2e-1048c9dc28e6",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"import",
                              "name":"DailySearchImport",
                              "component":"pages/production/internship-report/daily-manage/import-log",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"8c621453-2326-4261-a092-8997e0f613b7",
                              "pid":"929e6ad5-6b4e-4da4-9a2e-1048c9dc28e6",
                              "meta":{
                                  "title":"导入",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/internship-report/month-manage",
                      "name":"MonthManage",
                      "component":"Layout",
                      "redirect":"/production/internship-report/month-manage/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"44ab7e91-8725-410e-a32c-cf0c03cc6427",
                      "pid":"f313c949-d19a-46f2-8dff-979c56f8e5d0",
                      "meta":{
                          "title":"生产月报",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconshengchanyuebao-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"MonthManageList",
                              "component":"pages/production/internship-report/month-manage/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"d312e32d-ba20-426e-8ac6-66b0a68366af",
                              "pid":"44ab7e91-8725-410e-a32c-cf0c03cc6427",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/internship-report/duration-statistics",
                      "name":"DurationStatistics",
                      "component":"Layout",
                      "redirect":"/production/internship-report/duration-statistics/index",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"65532d84-8458-4d16-901e-d4e3b5e0f24e",
                      "pid":"f313c949-d19a-46f2-8dff-979c56f8e5d0",
                      "meta":{
                          "title":"工时统计",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjidishiyongqingkuang-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"index",
                              "name":"DurationStatisticsView",
                              "component":"pages/production/internship-report/duration-statistics/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"5aecc4b6-69fe-4fd3-b739-a2e467dd66f2",
                              "pid":"65532d84-8458-4d16-901e-d4e3b5e0f24e",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/internship-report/assessment",
                      "name":"Assessment",
                      "component":"Layout",
                      "redirect":"/production/internship-report/assessment/index",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":5,
                      "id":"a6c129fb-7f88-48b6-954d-7e89aa31d48e",
                      "pid":"f313c949-d19a-46f2-8dff-979c56f8e5d0",
                      "meta":{
                          "title":"能力考核",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconwenjuandiaocha-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"index",
                              "name":"AssessmentList",
                              "component":"pages/production/internship-report/assessment/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"738933c4-6b42-47b6-b50b-68b29b19222c",
                              "pid":"a6c129fb-7f88-48b6-954d-7e89aa31d48e",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/production/workload-manage",
              "name":"WorkloadManage",
              "component":"Layout",
              "redirect":"",
              "alwaysShow":false,
              "hidden":false,
              "sort":5,
              "id":"670a706a-c1ef-4377-b046-2a57db5ac5c1",
              "pid":"48ab0bda-0a15-4e56-a3d8-319c110e6244",
              "meta":{
                  "title":"工作量管理",
                  "icon":"icongongshitianbao",
                  "code":"",
                  "portalIcon":"",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/production/workload-manage/workload-indicator",
                      "name":"WorkloadIndicator",
                      "component":"Layout",
                      "redirect":"/production/workload-manage/workload-indicator/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"a6524097-27a0-4f53-9719-a07a0e0ae8cc",
                      "pid":"670a706a-c1ef-4377-b046-2a57db5ac5c1",
                      "meta":{
                          "title":"工作指标",
                          "icon":"",
                          "code":"",
                          "portalIcon":"icongangweifenxi-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"WorkloadIndicatorList",
                              "component":"pages/production/workload-manage/workload-indicator/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"fd01e477-b502-4d2e-9dd0-6350ee640e3c",
                              "pid":"a6524097-27a0-4f53-9719-a07a0e0ae8cc",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"WorkloadIndicatorCreate",
                              "component":"pages/production/workload-manage/workload-indicator/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"369b2992-1207-4d05-95cf-1ba7cff2719d",
                              "pid":"a6524097-27a0-4f53-9719-a07a0e0ae8cc",
                              "meta":{
                                  "title":"添加",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit/:id",
                              "name":"WorkloadIndicatorEdit",
                              "component":"pages/production/workload-manage/workload-indicator/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"65cf6ae9-6fd8-4972-9c36-2bb44385a0c5",
                              "pid":"a6524097-27a0-4f53-9719-a07a0e0ae8cc",
                              "meta":{
                                  "title":"修改",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"WorkloadIndicatorView",
                              "component":"pages/production/workload-manage/workload-indicator/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"ece67c83-dbeb-4f89-ae71-57536021af19",
                              "pid":"a6524097-27a0-4f53-9719-a07a0e0ae8cc",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/production/workload-manage/workload-statistics",
                      "name":"WorkloadStatistics",
                      "component":"Layout",
                      "redirect":"/production/workload-manage/workload-statistics/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"372b0851-106e-4a10-be41-a4c57b4057ed",
                      "pid":"670a706a-c1ef-4377-b046-2a57db5ac5c1",
                      "meta":{
                          "title":"工作汇总",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconxuefenguanlizhidu-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"WorkloadStatisticsList",
                              "component":"pages/production/workload-manage/workload-statistics/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ef4ecfa7-89b5-4d47-bc98-388875285f8a",
                              "pid":"372b0851-106e-4a10-be41-a4c57b4057ed",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"WorkloadStatisticsView",
                              "component":"pages/production/workload-manage/workload-statistics/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"40a50a36-682d-4c10-8528-5a28f0c0da12",
                              "pid":"372b0851-106e-4a10-be41-a4c57b4057ed",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          }
      ]
},
{
      "path":"/Teaching",
      "name":"学",
      "component":"pages/teaching/index",
      "redirect":null,
      "alwaysShow":false,
      "hidden":false,
      "sort":3,
      "id":"086f3a22-774c-4bb9-ae26-dad721ea15c5",
      "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
      "meta":{
          "title":"教学运行管理",
          "icon":"iconjiaoxueyunhang",
          "code":"",
          "portalIcon":null,
          "roles":[

          ]
      },
      "children":[
          {
              "path":"/Teaching/Teaching",
              "name":"Teaching",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":1,
              "id":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
              "pid":"086f3a22-774c-4bb9-ae26-dad721ea15c5",
              "meta":{
                  "title":"教学管理",
                  "icon":"icontool",
                  "code":"",
                  "portalIcon":"icontool2",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Teaching/Teaching/TeachingPlan",
                      "name":"TeachingPlan",
                      "component":"views/content/sas/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"537ff679-1578-4c36-9346-f2bacc30fc26",
                      "pid":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
                      "meta":{
                          "title":"动态授课计划",
                          "icon":"",
                          "code":"/TeachingPlan",
                          "portalIcon":"iconsimilar-product",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListTeachingPlan",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"049e1a86-9fd8-4f0b-8225-56daaf6027b0",
                              "pid":"537ff679-1578-4c36-9346-f2bacc30fc26",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"/TeachingManagement/ProfessionAbilityReSearch/Route",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewTeachingPlan",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"3175edc0-7a87-4c87-8899-e72a2dd3b810",
                              "pid":"537ff679-1578-4c36-9346-f2bacc30fc26",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"/TeachingManagement/ProfessionAbilityReSearch/Route",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateTeachingPlan",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"bb7df657-d5e8-40e0-990a-c4b4dca043a0",
                              "pid":"537ff679-1578-4c36-9346-f2bacc30fc26",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"/TeachingManagement/ProfessionAbilityReSearch/Route",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditTeachingPlan",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"57a1a313-44ba-4d00-ade2-aef1d7afde50",
                              "pid":"537ff679-1578-4c36-9346-f2bacc30fc26",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"/TeachingManagement/ProfessionAbilityReSearch/Route",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteTeachingPlan",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"50479480-84f4-4b56-8d9b-e5d37a1d5f85",
                              "pid":"537ff679-1578-4c36-9346-f2bacc30fc26",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"/TeachingManagement/ProfessionAbilityReSearch/Route",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Teaching/TaskNotification",
                      "name":"TaskNotification",
                      "component":"views/content/sas/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"f00b3093-173b-41e1-b178-4da997a6ab87",
                      "pid":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
                      "meta":{
                          "title":"学生在岗培养",
                          "icon":"",
                          "code":"/TaskNotification",
                          "portalIcon":"iconzhaozhuanjia",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListTaskNotification",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"8a308043-0d06-44b4-aa13-61415ab65588",
                              "pid":"f00b3093-173b-41e1-b178-4da997a6ab87",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"/TaskNotification",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewTaskNotification",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"c82876da-f26b-4c3a-bc16-72c61706c054",
                              "pid":"f00b3093-173b-41e1-b178-4da997a6ab87",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"/TaskNotification",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateTaskNotification",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"41da4ea7-05e4-4fa2-a419-f06e6465692f",
                              "pid":"f00b3093-173b-41e1-b178-4da997a6ab87",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"/TaskNotification",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditTaskNotification",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"fec27cc6-9638-4f5b-ba37-88491876095a",
                              "pid":"f00b3093-173b-41e1-b178-4da997a6ab87",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"/TaskNotification",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteTaskNotification",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"183c9260-77f2-4c51-a40d-bba1560e57ef",
                              "pid":"f00b3093-173b-41e1-b178-4da997a6ab87",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"/TaskNotification",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Teaching/LiveCourse",
                      "name":"LiveCourse",
                      "component":"views/content/live/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                      "pid":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
                      "meta":{
                          "title":"直播课堂",
                          "icon":"",
                          "code":"/LiveCourse",
                          "portalIcon":"iconzhibo1",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListMaterial",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"84f05c06-f925-4d7b-8ecf-434a42acc835",
                              "pid":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewMaterial",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"9bdf9c85-1cc7-4a0f-a30e-8f2437297828",
                              "pid":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateMaterial",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"672fdea5-a7c6-4a7d-8e5d-c6589b938120",
                              "pid":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditMaterial",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"7f645324-6a7b-48b1-965a-b75df7fe7072",
                              "pid":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteMaterial",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"a66cb0c7-672d-48ae-bda3-59c199fabe66",
                              "pid":"38ef384f-7a01-4596-b85b-1c114d1e37dc",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Teaching/Material",
                      "name":"Material",
                      "component":"views/content/sas/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":5,
                      "id":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                      "pid":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
                      "meta":{
                          "title":"课程资源",
                          "icon":"",
                          "code":"/Material",
                          "portalIcon":"iconkecheng",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListMaterial",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"fa5f5097-3563-4249-80f0-d102ed5008a8",
                              "pid":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewMaterial",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"32ef3f9b-41f8-415d-9ad5-1521401096db",
                              "pid":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateMaterial",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"e80f4b33-26e7-4ea0-b87d-2ec64566ec4d",
                              "pid":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditMaterial",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"1c13d61d-1497-4c79-95d0-5b8f43975af8",
                              "pid":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteMaterial",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"c24f6194-4cd0-43f7-a831-d0ffaaab537e",
                              "pid":"9d57dc50-fed7-48e0-828a-d6e955160ebd",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Teaching/Student",
                      "name":"Student",
                      "component":"views/content/sas/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":5,
                      "id":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                      "pid":"11eda131-2ce2-41c9-ab4f-092bcb2bfef9",
                      "meta":{
                          "title":"学生信息管理",
                          "icon":"",
                          "code":"/Student",
                          "portalIcon":"iconperson",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListMaterial",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ec9ddc4f-ef24-4df6-ad4e-1a8bff00ed49",
                              "pid":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewMaterial",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"c202639d-b8a5-4014-b8c5-b5afe8b55fd1",
                              "pid":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateMaterial",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"cb5fe5da-b6b2-445d-b125-242693fc76c4",
                              "pid":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditMaterial",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"ff02569b-fd43-42a6-9652-584b93a86160",
                              "pid":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteMaterial",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"ae1634ed-12b9-4637-acdc-9192c6a1dede",
                              "pid":"9be49621-1545-4a1b-8e1c-ca007b8336dd",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"/Material",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Teaching/Credit",
              "name":"Credit",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":4,
              "id":"e064c6be-e574-4dc7-88f0-f32bd55763d4",
              "pid":"086f3a22-774c-4bb9-ae26-dad721ea15c5",
              "meta":{
                  "title":"学分管理",
                  "icon":"iconSimilarproducts",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Teaching/Credit/CreditManagement",
                      "name":"CreditManagement",
                      "component":"Layout",
                      "redirect":"/Teaching/Credit/CreditManagement/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                      "pid":"e064c6be-e574-4dc7-88f0-f32bd55763d4",
                      "meta":{
                          "title":"学分管理制度",
                          "icon":"",
                          "code":"CreditManagement",
                          "portalIcon":"iconxuefenguanlizhidu-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListCreditManagement",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ff94e133-b7d4-48db-a6be-fa4531be4996",
                              "pid":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"CreditManagement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewCreditManagement",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"fea0b240-f4b5-46ae-ac30-518eb3af906f",
                              "pid":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"CreditManagement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateCreditManagement",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"59143d20-2ded-4d30-b086-fb1689428f23",
                              "pid":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"CreditManagement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditCreditManagement",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"e4f00959-6b6a-4674-8fda-fe734425e237",
                              "pid":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"CreditManagement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteCreditManagement",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"84eb9313-f8a6-4a34-8c9f-3495531bcbe3",
                              "pid":"52da93d5-6994-43cc-bd58-db7b09cb8600",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"CreditManagement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Credit/CreditAchievement",
                      "name":"CreditAchievement",
                      "component":"Layout",
                      "redirect":"/Teaching/Credit/CreditAchievement/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                      "pid":"e064c6be-e574-4dc7-88f0-f32bd55763d4",
                      "meta":{
                          "title":"学分管理成果",
                          "icon":"",
                          "code":"CreditAchievement",
                          "portalIcon":"iconxuefenguanlichengguo-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListCreditAchievement",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"6d881299-bba0-4069-9382-942297f60fc8",
                              "pid":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"CreditAchievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewCreditAchievement",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"7bf0c0a7-b9a9-482f-b5a8-e0195a55315e",
                              "pid":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"CreditAchievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateCreditAchievement",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"f52b2494-e2ba-438d-8e24-30043dfda955",
                              "pid":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"CreditAchievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditCreditAchievement",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"6a4020d5-218f-4b91-b9ae-82cddc4a095a",
                              "pid":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"CreditAchievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteCreditAchievement",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"401efbf9-0da4-45b8-a079-035e980e9e13",
                              "pid":"eac6bb27-df36-4c68-8a94-abb5e1159487",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"CreditAchievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Credit/credit-rule/",
                      "name":"CreditRule",
                      "component":"Layout",
                      "redirect":"/Teaching/Credit/credit-rule/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"77a72cd2-640d-43f4-9354-e471a1ed87b0",
                      "pid":"e064c6be-e574-4dc7-88f0-f32bd55763d4",
                      "meta":{
                          "title":"学分银行对接规则",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconxuefenyinhangduijieguize-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"ListCreditRule",
                              "component":"pages/teaching/credit-rule/list",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"bd0e6ebd-a3eb-44bf-a83b-426ff9b6c7a9",
                              "pid":"77a72cd2-640d-43f4-9354-e471a1ed87b0",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"CreateCreditRule",
                              "component":"pages/teaching/credit-rule/create",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"586eaede-693f-471b-aa56-a8e1b04a310f",
                              "pid":"77a72cd2-640d-43f4-9354-e471a1ed87b0",
                              "meta":{
                                  "title":"新增",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit/:id",
                              "name":"EditCreditRule",
                              "component":"pages/teaching/credit-rule/edit",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"ed9fd9c7-29c0-4740-a3bf-44c84b4174bf",
                              "pid":"77a72cd2-640d-43f4-9354-e471a1ed87b0",
                              "meta":{
                                  "title":"编辑",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"ViewCreditRule",
                              "component":"pages/teaching/credit-rule/view",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"439e25d5-82f2-454f-a46d-dc3275462d0c",
                              "pid":"77a72cd2-640d-43f4-9354-e471a1ed87b0",
                              "meta":{
                                  "title":"查看",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Teaching/Credit/student-credit",
                      "name":"StudentCredit",
                      "component":"Layout",
                      "redirect":"/Teaching/Credit/student-credit/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"b6c513a1-5f6a-4833-8b77-2aee1e29f812",
                      "pid":"e064c6be-e574-4dc7-88f0-f32bd55763d4",
                      "meta":{
                          "title":"学生学分管理",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconjiaoxueguanlixitong",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"ListStudentCredit",
                              "component":"pages/teaching/student-credit/list",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"c53b41aa-46cd-4cf6-8868-f7f866adf74f",
                              "pid":"b6c513a1-5f6a-4833-8b77-2aee1e29f812",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"CreateStudentCredit",
                              "component":"pages/teaching/student-credit/create",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"02d0d272-ee46-4eb4-8a1e-b10d5e9dfeea",
                              "pid":"b6c513a1-5f6a-4833-8b77-2aee1e29f812",
                              "meta":{
                                  "title":"新增",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit",
                              "name":"EditStudentCredit",
                              "component":"pages/teaching/student-credit/edit",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"c6086fca-0c9b-40af-b8b7-4596b7d1b1f6",
                              "pid":"b6c513a1-5f6a-4833-8b77-2aee1e29f812",
                              "meta":{
                                  "title":"编辑",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view",
                              "name":"ViewStudentCredit",
                              "component":"pages/teaching/student-credit/view",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"a7ffef95-a4b0-411b-9dc1-938ca966dd80",
                              "pid":"b6c513a1-5f6a-4833-8b77-2aee1e29f812",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/teaching/jobanalysis/",
              "name":"JobAnalysis",
              "component":"Layout",
              "redirect":"/teaching/jobanalysis/list",
              "alwaysShow":false,
              "hidden":false,
              "sort":5,
              "id":"8094d325-2922-4596-9dfb-4806477c55e9",
              "pid":"086f3a22-774c-4bb9-ae26-dad721ea15c5",
              "meta":{
                  "title":"岗位行业分析",
                  "icon":"iconsimilar-product",
                  "code":"",
                  "portalIcon":"icongangweifenxi-big",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"list",
                      "name":"ListJobAnalysis",
                      "component":"pages/teaching/job-analysis/list",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"d167a69c-db9f-4fcd-9942-a46346d01eb2",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"列表",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"create",
                      "name":"CreateJobAnalysis",
                      "component":"pages/teaching/job-analysis/create",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"49583dc2-2595-4d56-a589-33f9a5d91df0",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"新增",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"edit:/id",
                      "name":"EditJobAnalysis",
                      "component":"pages/teaching/job-analysis/edit",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"e7644521-e877-4e91-8ee1-e46d0364dccf",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"编辑",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"view:/id",
                      "name":"ViewJobAnalysis",
                      "component":"pages/teaching/job-analysis/view",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"5d42c2e0-7b95-4d47-9952-418e9b97db74",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"详情",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"sample:/id",
                      "name":"ListJobSample",
                      "component":"pages/teaching/job-analysis/sample-list",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"97d144de-34b3-4398-8781-c19313c743b4",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"样本数据",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"chart/:id",
                      "name":"ChartJobAnalysis",
                      "component":"pages/teaching/job-analysis/charts/index",
                      "redirect":"",
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":6,
                      "id":"d586247c-62e4-418c-a33d-416bd63e3de5",
                      "pid":"8094d325-2922-4596-9dfb-4806477c55e9",
                      "meta":{
                          "title":"分析结果",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          }
      ]
},
{
      "path":"/Research",
      "name":"研",
      "component":"",
      "redirect":null,
      "alwaysShow":false,
      "hidden":false,
      "sort":4,
      "id":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
      "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
      "meta":{
          "title":"应用技术开发项目",
          "icon":"iconyingyongjishukaifa",
          "code":"",
          "portalIcon":null,
          "roles":[

          ]
      },
      "children":[
          {
              "path":"/Research/ServicesManagement",
              "name":"ServicesManagement",
              "component":"Layout",
              "redirect":"",
              "alwaysShow":false,
              "hidden":false,
              "sort":1,
              "id":"39395015-9159-4f5d-a791-e25e9aae5229",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"社会服务管理",
                  "icon":"iconExportservices",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Research/ServicesManagement/ConsultingService",
                      "name":"ConsultingService",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/ConsultingService/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"咨询服务",
                          "icon":"",
                          "code":"ConsultingService",
                          "portalIcon":"iconzhuanjiazixun",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListConsultingService",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7db50f37-8ec4-417a-a2f7-d54f38dfc9aa",
                              "pid":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"ConsultingService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewConsultingService",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"328f4f74-f46a-4c9b-a049-77b179be9eb2",
                              "pid":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"ConsultingService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateConsultingService",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"e06dc69d-4309-44d2-bee3-df3958d39aeb",
                              "pid":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"ConsultingService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditConsultingService",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"dad2b77e-3482-46db-b67c-dd00b665b15f",
                              "pid":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"ConsultingService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteConsultingService",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"5ee1b5be-27dc-48ba-b395-a4424b62c4c5",
                              "pid":"06b2adf1-0b34-4513-b0b9-81b32f58cfbd",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"ConsultingService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/PublicService",
                      "name":"PublicService",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/PublicService/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"公益活动服务",
                          "icon":"",
                          "code":"PublicService",
                          "portalIcon":"icongongyihuodong",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListPublicService",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ba1f16f3-38ee-40e9-9cca-0130a14aa32e",
                              "pid":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"PublicService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewPublicService",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"a17ad27e-973c-4bd0-ad6e-8a4e578ff302",
                              "pid":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"PublicService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreatePublicService",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"71862e81-6545-4f6b-8e6a-fd1ef5d45136",
                              "pid":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"PublicService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditPublicService",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"48df87c5-7180-44c9-86c0-c255d48945a8",
                              "pid":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"PublicService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeletePublicService",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"a98725b0-3778-4706-ab67-3e06e1e24192",
                              "pid":"369f53ee-558d-4e7d-bedc-4bdfeb6dd478",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"PublicService",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/GuidingActivity",
                      "name":"GuidingActivity",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/GuidingActivity/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"新技术应用活动",
                          "icon":"",
                          "code":"GuidingActivity",
                          "portalIcon":"iconchuangxinjishu",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListGuidingActivity",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"63928f74-480a-492b-8ed8-97270bef1514",
                              "pid":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"GuidingActivity",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewGuidingActivity",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"82f4bc3e-383b-4cc4-aa79-5a9775d25b9e",
                              "pid":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"GuidingActivity",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateGuidingActivity",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"980e7f6d-0d2b-4b23-8491-7649eed53529",
                              "pid":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"GuidingActivity",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditGuidingActivity",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"36f2e598-ebb7-486a-a42d-61e774645e00",
                              "pid":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"GuidingActivity",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteGuidingActivity",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"5b3bc16f-1852-4859-a5c2-017b2902af2a",
                              "pid":"6a1bf85f-ab6e-46b9-a972-ed0ee7b4d422",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"GuidingActivity",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/TeachingResource",
                      "name":"TeachingResource",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/TeachingResource/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":4,
                      "id":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"成果管理与共享",
                          "icon":"",
                          "code":"TeachingResource",
                          "portalIcon":"iconchengguo1",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListTeachingResource",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"f715b604-1136-46e5-8992-4c63450052ed",
                              "pid":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"TeachingResource",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewTeachingResource",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"e8e27ce1-3a92-436f-828d-5a2882bb7a32",
                              "pid":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"TeachingResource",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateTeachingResource",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"d89a67b9-9ced-47be-bead-888d60bb0005",
                              "pid":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"TeachingResource",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditTeachingResource",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"fc46c0cf-93a0-4c50-a5d7-e317170ace36",
                              "pid":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"TeachingResource",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteTeachingResource",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"7557385c-5899-477f-a5f4-d65e445913c3",
                              "pid":"de73f41a-a591-44a3-b96d-65a1c42b71fe",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"TeachingResource",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/SocialServiceShow",
                      "name":"SocialServiceShow",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/SocialServiceShow/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":5,
                      "id":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"社会服务活动",
                          "icon":"",
                          "code":"SocialServiceShow",
                          "portalIcon":"iconshehuifuwu",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListSocialServiceShow",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ff1b64ac-c4f3-4530-b849-727c815ef9f0",
                              "pid":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"SocialServiceShow",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewSocialServiceShow",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"ef9189a1-cdbc-47a4-a641-41eafb9fddaf",
                              "pid":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"SocialServiceShow",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateSocialServiceShow",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"10f28777-4cf6-455d-affd-620490dd77f6",
                              "pid":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"SocialServiceShow",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditSocialServiceShow",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"9aa93ca8-237a-4346-ae5e-06e60b1d89fe",
                              "pid":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"SocialServiceShow",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteSocialServiceShow",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"b2756f18-cfb6-4775-8f63-0f7daa030834",
                              "pid":"12de19ea-41e6-45cb-85b7-2a33ebf5d542",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"SocialServiceShow",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/Expert",
                      "name":"Expert",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/Expert/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":6,
                      "id":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"专家导师",
                          "icon":"",
                          "code":"Expert",
                          "portalIcon":"iconzhuanjiazhanshi-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListExpert",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"bf3a9388-138f-43e4-99b2-a285ea73cbbb",
                              "pid":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewExpert",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"793b6378-1eed-4dc6-ad9e-acb5b2531b8f",
                              "pid":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateExpert",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"83c8db12-a311-48a7-b898-8166afa664f5",
                              "pid":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditExpert",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"bc5c2e97-6bd6-4769-a8fd-0b172370bd8d",
                              "pid":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteExpert",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"2ed5a18b-8405-449b-a48a-44a9b1347497",
                              "pid":"5a7e818e-42b4-4d97-87f1-8d2017ee48dc",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/research/services-management/train",
                      "name":"Train",
                      "component":"Layout",
                      "redirect":"/research/services-management/train/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":7,
                      "id":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"企业培训信息",
                          "icon":"",
                          "code":"Train",
                          "portalIcon":"iconqiyepeixun",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"trainApply/:id",
                              "name":"ListTrainApply",
                              "component":"pages/research/services-management/trainApply/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"dbc6517a-3c6a-42e9-a56b-08b1d445cd06",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"企业培训报名申请列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"trainAudit/:id",
                              "name":"AuditTrainApply",
                              "component":"pages/research/services-management/trainApply/audit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"c8b3349c-cf83-4aca-9339-7e9b3e5f0b40",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"企业培训报名审批",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"List",
                              "name":"ListTrain",
                              "component":"pages/research/services-management/train/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"78d93757-8663-4d85-975c-84df91804280",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Train",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewTrain",
                              "component":"pages/research/services-management/train/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"b109bf39-3c1b-4a60-a9e7-e27f697632ea",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Train",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateTrain",
                              "component":"pages/research/services-management/train/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"9f76fb78-92e0-4e25-bb0e-68e1200d0409",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Train",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditTrain",
                              "component":"pages/research/services-management/train/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"c1fb2857-3d10-4ebf-b98d-f0c8a4f5ef08",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Train",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteTrain",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"1bdc0a6c-6904-40d6-98f0-e76002cb8a83",
                              "pid":"9ff3d73a-d28b-4a1c-bc9b-0b6fe6b39981",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Train",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Research/ServicesManagement/PracticeJob",
                      "name":"PracticeJob",
                      "component":"Layout",
                      "redirect":"/Research/ServicesManagement/PracticeJob/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":10,
                      "id":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                      "pid":"39395015-9159-4f5d-a791-e25e9aae5229",
                      "meta":{
                          "title":"岗位实践",
                          "icon":"",
                          "code":"PracticeJob",
                          "portalIcon":"iconshijianfill",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListPracticeJob",
                              "component":"pages/research/services-management/job/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"17d6b3bf-1d66-4c69-95c2-0ee51646d45f",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"PracticeJob",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewPracticeJob",
                              "component":"pages/research/services-management/job/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"e39b7cc7-596f-448b-8447-d808648159df",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"PracticeJob",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"jobApply/:id",
                              "name":"ListJobApply",
                              "component":"pages/research/services-management/jobApply/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"12c68ecb-87b2-4663-9b1d-968a30ae86b7",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"岗位实践申请列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"jobAudio/:id",
                              "name":"AuditJobApply",
                              "component":"pages/research/services-management/jobApply/audit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"a1f6670d-100f-4e91-a3e8-377857a0386c",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"岗位实践审核",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreatePracticeJob",
                              "component":"pages/research/services-management/job/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"7ce126fb-2cfb-41a8-812e-e19a70e70980",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"PracticeJob",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditPracticeJob",
                              "component":"pages/research/services-management/job/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"c4059339-53ed-4b89-b0b1-056bdae1dcb6",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"PracticeJob",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeletePracticeJob",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"461b4e70-10cb-47ab-a65e-80e38e76ebf4",
                              "pid":"834d33f0-e1e6-42dd-b36b-0cd51221ba23",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"PracticeJob",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/ServiceAchievement",
              "name":"ServiceResult",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":2,
              "id":"ea14abaf-a714-4179-a474-cf001c611ad2",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"服务成效管理",
                  "icon":"iconchart-bar",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/service-achievement/exam-result",
                      "name":"ExamResult",
                      "component":"Layout",
                      "redirect":"/service-achievement/exam-result/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"21d95074-fb38-4ecb-b48c-95c653e50b3e",
                      "pid":"ea14abaf-a714-4179-a474-cf001c611ad2",
                      "meta":{
                          "title":"活动考核",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconhuodongkaohe-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"create",
                              "name":"CreateExamResult",
                              "component":"pages/research/service-achievement/exam-result/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"54de5f45-9451-42cc-b657-68f7694bc8df",
                              "pid":"21d95074-fb38-4ecb-b48c-95c653e50b3e",
                              "meta":{
                                  "title":"新增",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"List",
                              "name":"ExamResultIndex",
                              "component":"pages/research/service-achievement/exam-result/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"d67c5015-a33a-4829-ab07-68868cb6e4d2",
                              "pid":"21d95074-fb38-4ecb-b48c-95c653e50b3e",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"queryScoreByExam",
                              "name":"QueryScoreByExam",
                              "component":"pages/research/service-achievement/exam-result/queryScoreByExam",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"d8e5e4c4-0f55-4c18-b8f4-e597479a1255",
                              "pid":"21d95074-fb38-4ecb-b48c-95c653e50b3e",
                              "meta":{
                                  "title":"成绩填报",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/service-achievement/questionnaire",
                      "name":"Questionnaire",
                      "component":"Layout",
                      "redirect":"/service-achievement/questionnaire/index",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                      "pid":"ea14abaf-a714-4179-a474-cf001c611ad2",
                      "meta":{
                          "title":"问卷调查",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconwenjuandiaocha-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"index",
                              "name":"QuestionnaireIndex",
                              "component":"pages/research/service-achievement/questionnaire/index",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"fdc4ac32-e8cb-4150-b2c2-58e5dd0afe1f",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create",
                              "name":"QuestionnaireCreate",
                              "component":"pages/research/service-achievement/questionnaire/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"77d25639-6570-4dd9-9510-085b6835b4a4",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"新增",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit",
                              "name":"QuestionnaireEdit",
                              "component":"pages/research/service-achievement/questionnaire/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"19720f87-aebb-4f58-96c8-93c886d64939",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"编辑",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"explore",
                              "name":"QuestionnaireExplore",
                              "component":"pages/research/service-achievement/questionnaire/explore",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"0cab536a-80d6-4491-b0ef-c634a1065f01",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"预览",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"share",
                              "name":"QuestionnaireShare",
                              "component":"pages/research/service-achievement/questionnaire/share",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"70f38edd-60f5-4261-9eeb-8d0e192b3bee",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"分享",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"summary",
                              "name":"QuestionnaireSummary",
                              "component":"pages/research/service-achievement/questionnaire/summary",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":6,
                              "id":"1b502b65-b4e5-4da6-8497-8ceaac5d9d84",
                              "pid":"3533dd15-f004-4eb7-a46e-0936eeeef701",
                              "meta":{
                                  "title":"统计",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/ServicesTechnology",
              "name":"TechnicalSupport",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":3,
              "id":"d0316adf-aa75-4abf-bbaa-ed465c068d77",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"技术支持平台",
                  "icon":"iconfeeds",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/services-technology/question-answer",
                      "name":"QuestionAnswer",
                      "component":"Layout",
                      "redirect":"/services-technology/question-answer/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"cc165b9c-0275-476c-9747-4bab03f3319d",
                      "pid":"d0316adf-aa75-4abf-bbaa-ed465c068d77",
                      "meta":{
                          "title":"问答服务",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconwenda",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"detail",
                              "name":"QuestionAnswerDetail",
                              "component":"pages/research/services-technology/question-answer/detail",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"989e2a09-cb76-412e-bd11-c3dff9ced976",
                              "pid":"cc165b9c-0275-476c-9747-4bab03f3319d",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"QuestionAnswerView",
                              "component":"pages/research/services-technology/question-answer/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"b2b2a7d9-811b-4bee-9e62-f2537a03d6c7",
                              "pid":"cc165b9c-0275-476c-9747-4bab03f3319d",
                              "meta":{
                                  "title":"问答详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"List",
                              "name":"QuestionAnswerIndex",
                              "component":"pages/research/services-technology/question-answer/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"cb61bb57-bf18-469e-92a1-ec1875616dc3",
                              "pid":"cc165b9c-0275-476c-9747-4bab03f3319d",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/ServicesTechnology/Product",
                      "name":"Product",
                      "component":"Layout",
                      "redirect":"/ServicesTechnology/Product/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                      "pid":"d0316adf-aa75-4abf-bbaa-ed465c068d77",
                      "meta":{
                          "title":"产品介绍",
                          "icon":"",
                          "code":"Product",
                          "portalIcon":"iconchanpin",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListProduct",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"44399ac3-9ee5-491f-ab62-d09d46783ff1",
                              "pid":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Product",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewProduct",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"4ff713d7-88b1-4ae7-bb20-546daa3cc0e3",
                              "pid":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Product",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateProduct",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"7d81c66a-25a3-4aa6-875a-9f6cf64ece59",
                              "pid":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Product",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditProduct",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"8f50e578-f9f2-49f8-a68e-9441b2c6d8a9",
                              "pid":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Product",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteProduct",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"59d0c747-b559-44f9-842e-3fdf69dc55a0",
                              "pid":"80dabcd9-6cbb-4571-a664-fba456cc2333",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Product",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/ServicesTechnology/FAQ",
                      "name":"FAQ",
                      "component":"Layout",
                      "redirect":"/ServicesTechnology/FAQ/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"331c9dc6-e139-4418-b189-ad464a331849",
                      "pid":"d0316adf-aa75-4abf-bbaa-ed465c068d77",
                      "meta":{
                          "title":"在线FAQ",
                          "icon":"",
                          "code":"FAQ",
                          "portalIcon":"iconfaq",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListFAQ",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"926efacd-0b10-4985-9f08-73a40a199ac3",
                              "pid":"331c9dc6-e139-4418-b189-ad464a331849",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"FAQ",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewFAQ",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"2c2c1c1d-b481-495f-b8dc-472d831905ee",
                              "pid":"331c9dc6-e139-4418-b189-ad464a331849",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"FAQ",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateFAQ",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"010a05b1-905f-47b7-a208-b63058ec6356",
                              "pid":"331c9dc6-e139-4418-b189-ad464a331849",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"FAQ",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditFAQ",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"5009ced2-a4c7-4442-882b-9e98d84ae596",
                              "pid":"331c9dc6-e139-4418-b189-ad464a331849",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"FAQ",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteFAQ",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"3f3f9377-d593-4bb0-9d20-fb2ae6e37c12",
                              "pid":"331c9dc6-e139-4418-b189-ad464a331849",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"FAQ",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/ExpertManagement",
              "name":"ExpertManagement",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":4,
              "id":"1ca1c6d3-f35f-4b13-90d0-2b5b77041ba8",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"专家平台",
                  "icon":"iconperson",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/ExpertManagement/Expert",
                      "name":"Expert",
                      "component":"Layout",
                      "redirect":"/ExpertManagement/Expert/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                      "pid":"1ca1c6d3-f35f-4b13-90d0-2b5b77041ba8",
                      "meta":{
                          "title":"专家",
                          "icon":"",
                          "code":"Expert",
                          "portalIcon":"iconjishuzhuanjia",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListExpert",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"620c5c8e-4a6b-4300-93a4-0207ae3c01ed",
                              "pid":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewExpert",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"b293c9d1-6529-4c01-bc30-fcb3e9d1a58b",
                              "pid":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateExpert",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"56bf4cd6-ab1f-41d0-b098-c03712853cd0",
                              "pid":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditExpert",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"422f23d1-669a-4914-b6ba-4fd9f79fe15b",
                              "pid":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteExpert",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"65c0223e-2655-4f7a-ab36-d4dba65b9354",
                              "pid":"4a0601fd-7356-4cfe-9feb-caced3cc4c0f",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Expert",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/expert-management/order/",
                      "name":"ExpertOrder",
                      "component":"Layout",
                      "redirect":"/expert-management/order/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                      "pid":"1ca1c6d3-f35f-4b13-90d0-2b5b77041ba8",
                      "meta":{
                          "title":"专家订单",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconzhuanjiadingdan-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"EditOrder",
                              "component":"pages/research/expert-management/order/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"c2a77867-499b-478e-a82c-12ab7cafc513",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"detail",
                              "name":"DetailExpertOrder",
                              "component":"pages/research/expert-management/order/detail",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"89e7d018-be02-4314-81dd-fd48a5f8a2a2",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit",
                              "name":"EditOrder",
                              "component":"pages/research/expert-management/order/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"a395c6f9-f8fa-4431-bdff-9d6f9515932d",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"修改",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateExpertOrder",
                              "component":"pages/research/expert-management/order/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"218f8119-1fa8-44d9-b94c-d0b7a51efe56",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"添加",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"suggestion-create",
                              "name":"SuggestionCreate",
                              "component":"pages/research/expert-management/order-suggestion/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"3204705c-8deb-442e-9b90-38e4ac12e0cc",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"新增指导资料",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"suggestion-detail",
                              "name":"SuggestionDetail",
                              "component":"pages/research/expert-management/order-suggestion/detail",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":6,
                              "id":"bf52ab32-15e7-4993-a12e-f47ff74c523f",
                              "pid":"61d29ea5-6508-4bdb-8952-9ecb2731cad5",
                              "meta":{
                                  "title":"指导资料详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Research/Achievement",
              "name":"Achievement",
              "component":"Layout",
              "redirect":"/Research/Achievement/List",
              "alwaysShow":false,
              "hidden":false,
              "sort":5,
              "id":"a719e16a-c664-4fe9-b342-d82f91018d57",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"成果宣传",
                  "icon":"iconicon_sketch",
                  "code":"Achievement",
                  "portalIcon":"iconicon_sketch",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"List",
                      "name":"ListAchievement",
                      "component":"views/content/data-set/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"73f49e41-b407-4525-b79f-a751b9372913",
                      "pid":"a719e16a-c664-4fe9-b342-d82f91018d57",
                      "meta":{
                          "title":"列表",
                          "icon":null,
                          "code":"Achievement",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"View",
                      "name":"ViewAchievement",
                      "component":"views/content/data-set/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"c2e4a67b-baa7-497d-a2da-f0377f2ab949",
                      "pid":"a719e16a-c664-4fe9-b342-d82f91018d57",
                      "meta":{
                          "title":"详情",
                          "icon":null,
                          "code":"Achievement",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Create",
                      "name":"CreateAchievement",
                      "component":"views/content/data-set/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"19eec4ba-bbab-4fa0-8fdf-785d53063a5a",
                      "pid":"a719e16a-c664-4fe9-b342-d82f91018d57",
                      "meta":{
                          "title":"添加",
                          "icon":null,
                          "code":"Achievement",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Edit",
                      "name":"EditAchievement",
                      "component":"views/content/data-set/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"07e8cf67-1eb9-4cb7-8b92-9119c2b9103f",
                      "pid":"a719e16a-c664-4fe9-b342-d82f91018d57",
                      "meta":{
                          "title":"修改",
                          "icon":null,
                          "code":"Achievement",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Delete",
                      "name":"DeleteAchievement",
                      "component":null,
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"dbe7d833-522f-4c59-be2d-3cbdd359406c",
                      "pid":"a719e16a-c664-4fe9-b342-d82f91018d57",
                      "meta":{
                          "title":"删除",
                          "icon":null,
                          "code":"Achievement",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/ProjectManagement",
              "name":"ProjectManagement",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":6,
              "id":"73461d93-9bd3-4693-84d5-f2a55913ea6f",
              "pid":"1cb64b70-8c7b-4721-9aa8-dcb12bda4324",
              "meta":{
                  "title":"项目管理",
                  "icon":"iconintegral",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/ProjectManagement/ProjectMaterial",
                      "name":"ProjectMaterial",
                      "component":"Layout",
                      "redirect":"/ProjectManagement/ProjectMaterial/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                      "pid":"73461d93-9bd3-4693-84d5-f2a55913ea6f",
                      "meta":{
                          "title":"项目申请资料",
                          "icon":"",
                          "code":"ProjectMaterial",
                          "portalIcon":"iconshenqingziliao",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListProjectMaterial",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"d7e8cf24-5b94-4266-ac78-ef65ebdff504",
                              "pid":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"ProjectMaterial",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewProjectMaterial",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"1b39ac73-63eb-40d2-be10-97bfda1418fe",
                              "pid":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"ProjectMaterial",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateProjectMaterial",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"bddce2cc-9795-402d-9f58-ffca3d4dce2d",
                              "pid":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"ProjectMaterial",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditProjectMaterial",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"7f3f3ce3-ecd0-4abc-bec2-f121fbb61e61",
                              "pid":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"ProjectMaterial",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteProjectMaterial",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"41e2a392-7989-4a3d-87f4-941bd919e8b2",
                              "pid":"e11aa77b-f38a-45a6-bf1a-c06e6c5a62da",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"ProjectMaterial",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/project-management/",
                      "name":"Project",
                      "component":"Layout",
                      "redirect":"/project-management/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"cd058b54-ac95-4257-b21f-6f11c7cca4ed",
                      "pid":"73461d93-9bd3-4693-84d5-f2a55913ea6f",
                      "meta":{
                          "title":"应用技术开发项目",
                          "icon":"",
                          "code":"",
                          "portalIcon":"iconxiangmuguanli-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"monitorDetail",
                              "name":"MonitorDetail",
                              "component":"pages/research/project-management/monitorDetail",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"b243abbd-6fb3-497d-8137-a3ae61c66973",
                              "pid":"cd058b54-ac95-4257-b21f-6f11c7cca4ed",
                              "meta":{
                                  "title":"项目监控详情",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"List",
                              "name":"ListProject",
                              "component":"pages/research/project-management/index",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"51a3dd30-b8af-4608-b1b5-eb91d8a8b73a",
                              "pid":"cd058b54-ac95-4257-b21f-6f11c7cca4ed",
                              "meta":{
                                  "title":"列表",
                                  "icon":"",
                                  "code":"ExpertSuggest",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"detail",
                              "name":"DetailProject",
                              "component":"pages/research/project-management/detail",
                              "redirect":"",
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"f2c09783-6347-4dba-8cb0-d7accd49b391",
                              "pid":"cd058b54-ac95-4257-b21f-6f11c7cca4ed",
                              "meta":{
                                  "title":"详情",
                                  "icon":"",
                                  "code":"ExpertSuggest",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"monitor",
                              "name":"MonitorProject",
                              "component":"pages/research/project-management/monitor",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7103b383-a5cc-4a2b-93e6-e8bd32077bec",
                              "pid":"cd058b54-ac95-4257-b21f-6f11c7cca4ed",
                              "meta":{
                                  "title":"项目监控",
                                  "icon":"",
                                  "code":"",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          }
      ]
},
{
      "path":"/Innovate",
      "name":"创",
      "component":"",
      "redirect":null,
      "alwaysShow":false,
      "hidden":false,
      "sort":5,
      "id":"1568cea9-6bce-421b-91b0-f6aeed798488",
      "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
      "meta":{
          "title":"学生创新创业",
          "icon":"iconxueshengchuangxinchuangye",
          "code":"",
          "portalIcon":null,
          "roles":[

          ]
      },
      "children":[
          {
              "path":"/Information",
              "name":"information",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":1,
              "id":"5d1d40fb-74b8-4fc1-8d10-715f6cff218e",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"新闻资讯",
                  "icon":"iconzixun",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Innovate/Information/RegionalPaper",
                      "name":"RegionalPaper",
                      "component":"Layout",
                      "redirect":"/Innovate/Information/RegionalPaper/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                      "pid":"5d1d40fb-74b8-4fc1-8d10-715f6cff218e",
                      "meta":{
                          "title":"区域白皮书",
                          "icon":"",
                          "code":"RegionalPaper",
                          "portalIcon":"iconbaipishu",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListRegionalPaper",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"9c14dd4c-1c05-4d16-bc9d-6d8906ebe34a",
                              "pid":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"RegionalPaper",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewRegionalPaper",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"e2090f98-7c04-4994-b0f1-70e78771085f",
                              "pid":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"RegionalPaper",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateRegionalPaper",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"c612a3d8-e49f-47d4-b431-305acf448029",
                              "pid":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"RegionalPaper",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditRegionalPaper",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"d3669924-a307-4890-b67e-466e607b24f6",
                              "pid":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"RegionalPaper",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteRegionalPaper",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"efe33278-f1cf-4c64-a077-0427043b616a",
                              "pid":"9e41f9ca-7772-41bc-b846-851d2bb10d68",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"RegionalPaper",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Innovate/Information/TopNews",
                      "name":"TopNews",
                      "component":"Layout",
                      "redirect":"/Innovate/Information/TopNews/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                      "pid":"5d1d40fb-74b8-4fc1-8d10-715f6cff218e",
                      "meta":{
                          "title":"热门新闻动态资讯",
                          "icon":"",
                          "code":"TopNews",
                          "portalIcon":"iconnews1",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListTopNews",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"c22f35ba-f220-444d-b81f-0386178aa271",
                              "pid":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"TopNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewTopNews",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"eb66495a-a3cb-43fe-9005-2985d7a620bb",
                              "pid":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"TopNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateTopNews",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"c3d3c3e5-4638-4d48-8b2f-7be75f831c33",
                              "pid":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"TopNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditTopNews",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"8d8d6338-1199-41cd-a0e5-eee78fdce003",
                              "pid":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"TopNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteTopNews",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"78f1a20e-0f32-44f2-94ae-f9fc3d48668f",
                              "pid":"aa79ace0-02ad-4999-b62b-7a6378652ff8",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"TopNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Innovate/Information/EntrepreneurshipGuide",
                      "name":"EntrepreneurshipGuide",
                      "component":"Layout",
                      "redirect":"/Innovate/Information/EntrepreneurshipGuide/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"5077edc0-05c0-4369-bf24-2b649287e249",
                      "pid":"5d1d40fb-74b8-4fc1-8d10-715f6cff218e",
                      "meta":{
                          "title":"行业创业指南",
                          "icon":"",
                          "code":"EntrepreneurshipGuide",
                          "portalIcon":"iconchuangyezhinan",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListEntrepreneurshipGuide",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"be281baa-65af-4c6a-adf1-00583d0793b7",
                              "pid":"5077edc0-05c0-4369-bf24-2b649287e249",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"EntrepreneurshipGuide",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewEntrepreneurshipGuide",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"20ffbb64-df59-4296-9e41-4a0d5d83f39e",
                              "pid":"5077edc0-05c0-4369-bf24-2b649287e249",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"EntrepreneurshipGuide",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateEntrepreneurshipGuide",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"1574ceda-936e-435b-bb64-d9b4eb9e1638",
                              "pid":"5077edc0-05c0-4369-bf24-2b649287e249",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"EntrepreneurshipGuide",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditEntrepreneurshipGuide",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"b2a1d515-6e72-4764-bef0-cf9a75d4fce3",
                              "pid":"5077edc0-05c0-4369-bf24-2b649287e249",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"EntrepreneurshipGuide",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteEntrepreneurshipGuide",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"9a737cd8-5894-42b2-9b69-3f25e1f67116",
                              "pid":"5077edc0-05c0-4369-bf24-2b649287e249",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"EntrepreneurshipGuide",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/InnovationPolicy",
              "name":"InnovationPolicy",
              "component":"Layout",
              "redirect":"/Innovate/InnovationPolicy/List",
              "alwaysShow":false,
              "hidden":false,
              "sort":3,
              "id":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"双创政策",
                  "icon":"iconassessed-badge",
                  "code":"InnovationPolicy",
                  "portalIcon":"iconzhengce",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"List",
                      "name":"ListInnovationPolicy",
                      "component":"views/content/data-set/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"922e5511-1063-40a7-a53a-b4d125e4f9a9",
                      "pid":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
                      "meta":{
                          "title":"列表",
                          "icon":null,
                          "code":"InnovationPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"View",
                      "name":"ViewInnovationPolicy",
                      "component":"views/content/data-set/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"0c4825fc-8fa1-48f7-9e49-46a6b316798c",
                      "pid":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
                      "meta":{
                          "title":"详情",
                          "icon":null,
                          "code":"InnovationPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Create",
                      "name":"CreateInnovationPolicy",
                      "component":"views/content/data-set/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"bd6574e0-5c35-4fee-8263-cb96b05aae48",
                      "pid":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
                      "meta":{
                          "title":"添加",
                          "icon":null,
                          "code":"InnovationPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Edit",
                      "name":"EditInnovationPolicy",
                      "component":"views/content/data-set/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"69b7bca8-c81d-4c6b-80b5-2a7c6886f12d",
                      "pid":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
                      "meta":{
                          "title":"修改",
                          "icon":null,
                          "code":"InnovationPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Delete",
                      "name":"DeleteInnovationPolicy",
                      "component":null,
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"30ad39b3-62f0-4b23-9383-d1dfe0356cf0",
                      "pid":"81ddcf0c-429f-4fa4-a804-05d8e6dc1dff",
                      "meta":{
                          "title":"删除",
                          "icon":null,
                          "code":"InnovationPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/roadshow",
              "name":"Roadshow",
              "component":"Layout",
              "redirect":"/Innovate/roadshow/list",
              "alwaysShow":false,
              "hidden":false,
              "sort":4,
              "id":"e8713f7b-e10e-4344-a716-71a19d798a3f",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"路演信息",
                  "icon":"iconicon_video",
                  "code":"1d8096e7-3304-4f5d-8d36-2a2a6e674ea8",
                  "portalIcon":"iconicon_video",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"list",
                      "name":"RoadshowList",
                      "component":"pages/innovate/roadshow-hall/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"82cd8731-e36a-404b-8421-d9220432859c",
                      "pid":"e8713f7b-e10e-4344-a716-71a19d798a3f",
                      "meta":{
                          "title":"列表",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"view/:id",
                      "name":"RoadshowView",
                      "component":"pages/innovate/roadshow-hall/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"c77af0e0-0340-4d44-bc3e-0006a67e3273",
                      "pid":"e8713f7b-e10e-4344-a716-71a19d798a3f",
                      "meta":{
                          "title":"详情",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"create/:id",
                      "name":"RoadshowCreate",
                      "component":"pages/innovate/roadshow-hall/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"a19dbc90-4b85-444b-a350-ecb15a5cdc38",
                      "pid":"e8713f7b-e10e-4344-a716-71a19d798a3f",
                      "meta":{
                          "title":"添加",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"edit/:id",
                      "name":"RoadshowEdit",
                      "component":"pages/innovate/roadshow-hall/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"0150b17b-d101-4824-af78-4c2947d8fb62",
                      "pid":"e8713f7b-e10e-4344-a716-71a19d798a3f",
                      "meta":{
                          "title":"修改",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"approve/:id",
                      "name":"RoadshowApprove",
                      "component":"pages/innovate/roadshow-hall/approve",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"bcc5657e-ef01-4204-94d8-868d280c4bd9",
                      "pid":"e8713f7b-e10e-4344-a716-71a19d798a3f",
                      "meta":{
                          "title":"审批",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/match",
              "name":"Match",
              "component":"Layout",
              "redirect":"/Innovate/match/list",
              "alwaysShow":false,
              "hidden":false,
              "sort":5,
              "id":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"赛事信息",
                  "icon":"iconsaishi",
                  "code":"7d6b09ec-9575-4cd0-95a5-20ae9bba1336",
                  "portalIcon":"iconsaishi",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"list",
                      "name":"MatchList",
                      "component":"pages/innovate/match/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"29275894-8748-4822-a185-fea109a3f0f3",
                      "pid":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
                      "meta":{
                          "title":"列表",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"view/:id",
                      "name":"MatchView",
                      "component":"pages/innovate/match/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"ef4d8287-5d22-49a0-8884-aa88a82c9e18",
                      "pid":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
                      "meta":{
                          "title":"详情",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"create",
                      "name":"MatchCreate",
                      "component":"pages/innovate/match/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"e94e456d-2a21-478a-bd22-77cba8ae1167",
                      "pid":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
                      "meta":{
                          "title":"添加",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"edit/:id",
                      "name":"MatchEdit",
                      "component":"pages/innovate/match/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"403d4a07-2e40-4374-b3fa-1a0190f96617",
                      "pid":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
                      "meta":{
                          "title":"修改",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"approve/:id",
                      "name":"MatchEdit",
                      "component":"pages/innovate/match/approve",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"d46de509-dd79-4206-a0a7-60f3243cc36d",
                      "pid":"027e9077-be1b-4b8f-9a39-970592e8a5fe",
                      "meta":{
                          "title":"审批",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/innovation-items",
              "name":"InnovationItems",
              "component":"Layout",
              "redirect":"/Innovate/innovation-items/list",
              "alwaysShow":false,
              "hidden":false,
              "sort":6,
              "id":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"双创项目",
                  "icon":"iconjizhi",
                  "code":"0f7113f6-22bc-448b-a197-95030e801680",
                  "portalIcon":"iconjizhi",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"list",
                      "name":"InnovationItemsList",
                      "component":"pages/innovate/innovation-project/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"8cb4fb52-8f5d-4274-a7cf-c387d5b80b56",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"列表",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"view/:id",
                      "name":"InnovationItemsView",
                      "component":"pages/innovate/innovation-project/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"19e87a88-db0d-4786-9afa-c4b039f6aaa6",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"详情",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"create/:id",
                      "name":"InnovationItemsCreate",
                      "component":"pages/innovate/innovation-project/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"d4776a76-0fb3-49f4-a67a-3a3490fa844b",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"添加",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"edit/:id",
                      "name":"InnovationItemsEdit",
                      "component":"pages/innovate/innovation-project/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"64a1ce95-3a5d-490a-8a6a-f021337d2142",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"修改",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"approve/:id",
                      "name":"InnovationItemsApprove",
                      "component":"pages/innovate/innovation-project/approve",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"b0cd9433-dfb3-4e41-8d6e-c96773e285a4",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"审批",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"publish/:id",
                      "name":"InnovationItemsPublish",
                      "component":"pages/innovate/innovation-project/publish",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":6,
                      "id":"3bc8a1ad-ceb7-4b45-931a-1b3544cac326",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"公示",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"report/:id",
                      "name":"InnovationItemsReport",
                      "component":"pages/innovate/innovation-project/report",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":7,
                      "id":"2ac52a09-5703-4134-8415-05e8725f41e5",
                      "pid":"a11fe0aa-9d53-47f4-a1ea-e66d4b605760",
                      "meta":{
                          "title":"可行性报告",
                          "icon":"",
                          "code":"",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/investment",
              "name":"investment",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":7,
              "id":"84ee5d55-6990-4081-9a86-bf88e81d2186",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"投融资服务",
                  "icon":"iconMoneydollarfinancebusiness",
                  "code":"",
                  "portalIcon":"icontourongzifuwu-big",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Innovate/investment/innovation-project",
                      "name":"InnovationProject",
                      "component":"Layout",
                      "redirect":"/Innovate/investment/innovation-project/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"9e199dc8-44db-467f-aadb-9687518857a1",
                      "pid":"84ee5d55-6990-4081-9a86-bf88e81d2186",
                      "meta":{
                          "title":"项目投资",
                          "icon":"",
                          "code":"InnovationProject",
                          "portalIcon":"icontourongzi",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"ListInnovationProject",
                              "component":"pages/innovate/project-investment/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"34b46101-9de3-4607-a393-2467a62cf56a",
                              "pid":"9e199dc8-44db-467f-aadb-9687518857a1",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"InnovationProject",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"ViewInnovationProject",
                              "component":"pages/innovate/project-investment/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"b1a2c65e-776e-48af-a6fe-a22a730bf4ac",
                              "pid":"9e199dc8-44db-467f-aadb-9687518857a1",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"InnovationProject",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Innovate/investment/investor",
                      "name":"Investor",
                      "component":"Layout",
                      "redirect":"/Innovate/investment/investor/list",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                      "pid":"84ee5d55-6990-4081-9a86-bf88e81d2186",
                      "meta":{
                          "title":"投资人",
                          "icon":"",
                          "code":"Investor",
                          "portalIcon":"icontouziren",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"list",
                              "name":"InvestorList",
                              "component":"pages/innovate/investment/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"13a42611-045f-4d0c-9267-1f2cf3eec609",
                              "pid":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Investor",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"view/:id",
                              "name":"InvestorView",
                              "component":"pages/innovate/investment/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"fd50b065-03d7-468b-bc74-cba83d6c3b69",
                              "pid":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Investor",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"create/:id",
                              "name":"InvestorCreate",
                              "component":"pages/innovate/investment/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"aa3ce95e-9e36-4c2e-8677-abef5ca40ae2",
                              "pid":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Investor",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"edit/:id",
                              "name":"InvestorEdit",
                              "component":"pages/innovate/investment/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"d7e66e79-0778-4454-8cf7-bec5026fe556",
                              "pid":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Investor",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"approve/:id",
                              "name":"InvestorApprove",
                              "component":"pages/innovate/investment/approve",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"b6a8f8a6-8acf-4f5d-9a18-5eca1d98a90a",
                              "pid":"5c3824d3-c717-49d1-8f1d-ccc10650c093",
                              "meta":{
                                  "title":"审批",
                                  "icon":null,
                                  "code":"Investor",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Innovate/investment/InvestmentNews",
                      "name":"InvestmentNews",
                      "component":"Layout",
                      "redirect":"/Innovate/investment/InvestmentNews/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":3,
                      "id":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                      "pid":"84ee5d55-6990-4081-9a86-bf88e81d2186",
                      "meta":{
                          "title":"投资资讯",
                          "icon":"",
                          "code":"InvestmentNews",
                          "portalIcon":"iconzixun",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListInvestmentNews",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"8f3e32ba-7744-4bfc-bc27-40f17dbbd391",
                              "pid":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"InvestmentNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewInvestmentNews",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"afa634a7-39ff-41a6-a64a-0c2f90e44a73",
                              "pid":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"InvestmentNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateInvestmentNews",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"7dc56234-833f-4704-aecd-79f711fa8f99",
                              "pid":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"InvestmentNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditInvestmentNews",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"7f366425-d7cf-4b3c-bcde-572c38410fba",
                              "pid":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"InvestmentNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteInvestmentNews",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"d4539554-9c7d-4b0f-b799-07943c4a84eb",
                              "pid":"d2425c21-eb24-49af-b7aa-215d41a1cd87",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"InvestmentNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/Tutor",
              "name":"Tutor",
              "component":"Layout",
              "redirect":"/Innovate/Tutor/List",
              "alwaysShow":false,
              "hidden":false,
              "sort":8,
              "id":"e02a3cd6-7728-493d-b174-8a502091c0f1",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"双创导师",
                  "icon":"iconzhaozhuanjia",
                  "code":"Tutor",
                  "portalIcon":"iconzhaozhuanjia",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"List",
                      "name":"ListTutor",
                      "component":"pages/innovate/tutor/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"ebefe29e-5192-4aa6-b92f-8571adaba0ad",
                      "pid":"e02a3cd6-7728-493d-b174-8a502091c0f1",
                      "meta":{
                          "title":"列表",
                          "icon":null,
                          "code":"Tutor",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"View",
                      "name":"ViewTutor",
                      "component":"pages/innovate/tutor/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"7ce4c4da-245f-49ad-9b51-3e3fd0df3915",
                      "pid":"e02a3cd6-7728-493d-b174-8a502091c0f1",
                      "meta":{
                          "title":"详情",
                          "icon":null,
                          "code":"Tutor",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Create",
                      "name":"CreateTutor",
                      "component":"pages/innovate/tutor/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"5b284f15-97d6-4d23-b5dd-73a10db82c5a",
                      "pid":"e02a3cd6-7728-493d-b174-8a502091c0f1",
                      "meta":{
                          "title":"添加",
                          "icon":null,
                          "code":"Tutor",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Edit",
                      "name":"EditTutor",
                      "component":"pages/innovate/tutor/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"2aaa1e54-6207-4f9b-b3e9-a5c7337cb2da",
                      "pid":"e02a3cd6-7728-493d-b174-8a502091c0f1",
                      "meta":{
                          "title":"修改",
                          "icon":null,
                          "code":"Tutor",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Delete",
                      "name":"DeleteTutor",
                      "component":null,
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"b9069dca-bc39-49ac-9d72-a09e61cb1aec",
                      "pid":"e02a3cd6-7728-493d-b174-8a502091c0f1",
                      "meta":{
                          "title":"删除",
                          "icon":null,
                          "code":"Tutor",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Innovate/League",
              "name":"League",
              "component":"Layout",
              "redirect":"",
              "alwaysShow":false,
              "hidden":false,
              "sort":9,
              "id":"37530267-c012-4c2f-a354-d8a685117c99",
              "pid":"1568cea9-6bce-421b-91b0-f6aeed798488",
              "meta":{
                  "title":"创业联盟",
                  "icon":"iconfeeds",
                  "code":"",
                  "portalIcon":"iconfeeds",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Innovate/League/League",
                      "name":"League",
                      "component":"Layout",
                      "redirect":"/Innovate/League/League/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                      "pid":"37530267-c012-4c2f-a354-d8a685117c99",
                      "meta":{
                          "title":"联盟信息",
                          "icon":"",
                          "code":"League",
                          "portalIcon":"iconlianmeng1",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListLeague",
                              "component":"pages/innovate/alliance/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"dfdd13e5-d388-4608-bb38-c6b1dda4b03d",
                              "pid":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"League",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewLeague",
                              "component":"pages/innovate/alliance/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"f9105b32-cb79-49cf-81af-b24d0cf726fa",
                              "pid":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"League",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateLeague",
                              "component":"pages/innovate/alliance/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"c0233bd4-794f-45f2-9097-dadfa53f53b5",
                              "pid":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"League",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditLeague",
                              "component":"pages/innovate/alliance/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"87773bc6-86bc-4e24-86ad-3f70973f062a",
                              "pid":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"League",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteLeague",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"791e1d39-f15b-4315-b2e5-9dd33cac268d",
                              "pid":"8df25b6d-f8ea-42a1-8703-7fac691ec383",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"League",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Innovate/League/LeagueNews",
                      "name":"LeagueNews",
                      "component":"Layout",
                      "redirect":"/Innovate/League/LeagueNews/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                      "pid":"37530267-c012-4c2f-a354-d8a685117c99",
                      "meta":{
                          "title":"动态新闻",
                          "icon":"",
                          "code":"LeagueNews",
                          "portalIcon":"iconnews1",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListLeagueNews",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"c3d650f5-20d8-4152-84f6-d00dec7be45f",
                              "pid":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"LeagueNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewLeagueNews",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"7931f740-e4a0-4eb9-9ec9-5d62a1b13a2d",
                              "pid":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"LeagueNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateLeagueNews",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"fcfb395b-46e3-42f8-bf3e-9a98f6c50b3b",
                              "pid":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"LeagueNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditLeagueNews",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"1b9b598c-bb34-41a4-bfc4-124bbced576b",
                              "pid":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"LeagueNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteLeagueNews",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"3f46ea07-a6d8-4c99-8452-155eca14da69",
                              "pid":"126ee6b5-5b51-499b-a126-918fcc9f9c7f",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"LeagueNews",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          }
      ]
},
{
      "path":"/Translate",
      "name":"转",
      "component":"",
      "redirect":null,
      "alwaysShow":false,
      "hidden":false,
      "sort":6,
      "id":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
      "pid":"8aa31ebd-cc85-11ea-b4ea-0242ac110003",
      "meta":{
          "title":"成果转化系统",
          "icon":"iconzhuan-big",
          "code":"",
          "portalIcon":null,
          "roles":[

          ]
      },
      "children":[
          {
              "path":"/Translate/Achievement",
              "name":"Achievement",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":1,
              "id":"6afc988a-608a-4cec-8c70-0466f3f8d4c4",
              "pid":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
              "meta":{
                  "title":"成果展示",
                  "icon":"iconicon_sketch",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Translate/Achievement/Achievement",
                      "name":"Achievement",
                      "component":"Layout",
                      "redirect":"/Translate/Achievement/Achievement/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                      "pid":"6afc988a-608a-4cec-8c70-0466f3f8d4c4",
                      "meta":{
                          "title":"成果管理",
                          "icon":"",
                          "code":"Achievement",
                          "portalIcon":"iconicon_sketch",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListAchievement",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"b8cf106f-c4e0-445d-b63e-ee97f709428a",
                              "pid":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Achievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewAchievement",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"ab4f0d57-f01c-4a86-a83b-96375b5d30f9",
                              "pid":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Achievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateAchievement",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"92f9ca2d-50bc-4507-9e94-a9ced4ba9014",
                              "pid":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Achievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditAchievement",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"75650e63-1ab5-4e8c-97b3-4dc02ec4756f",
                              "pid":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Achievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteAchievement",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"cd31076c-955f-4148-9f30-b46ccd4f4ac3",
                              "pid":"071fdd18-9be2-4675-b8e2-ef5b5bd2df6d",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Achievement",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Translate/Achievement/Scientific",
                      "name":"Scientific",
                      "component":"Layout",
                      "redirect":"/Translate/Achievement/Scientific/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                      "pid":"6afc988a-608a-4cec-8c70-0466f3f8d4c4",
                      "meta":{
                          "title":"科研单位",
                          "icon":"",
                          "code":"Scientific",
                          "portalIcon":"iconkeyan",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListScientific",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7fb3c806-e470-472d-a97d-d8fd0abb4eb8",
                              "pid":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Scientific",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewScientific",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"bfe72507-8dc1-44a9-ba90-aa994040747e",
                              "pid":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Scientific",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateScientific",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"e2d7f2d2-1787-412d-8d6b-7f0bfa90d2c1",
                              "pid":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Scientific",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditScientific",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"71d4e8e5-f119-47a7-bbfa-621f6a96d576",
                              "pid":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Scientific",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteScientific",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"c871bafa-4315-45c2-9aa1-269083b8f33e",
                              "pid":"08b198d1-644d-4c37-8bab-34b63a69c8a8",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Scientific",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Translate/AchievementPolicy",
              "name":"AchievementPolicy",
              "component":"Layout",
              "redirect":"/Translate/AchievementPolicy/List",
              "alwaysShow":false,
              "hidden":false,
              "sort":2,
              "id":"af4fd487-0352-4fa5-b811-ec35b340681a",
              "pid":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
              "meta":{
                  "title":"体制机制创新",
                  "icon":"iconfeeds",
                  "code":"AchievementPolicy",
                  "portalIcon":"iconfeeds",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"List",
                      "name":"ListAchievementPolicy",
                      "component":"views/content/data-set/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"7bb8352d-6bac-4cc9-93ce-7813ae7d5c0a",
                      "pid":"af4fd487-0352-4fa5-b811-ec35b340681a",
                      "meta":{
                          "title":"列表",
                          "icon":null,
                          "code":"AchievementPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"View",
                      "name":"ViewAchievementPolicy",
                      "component":"views/content/data-set/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"9b33fb2d-b1a1-4aef-bc23-657eeef601ca",
                      "pid":"af4fd487-0352-4fa5-b811-ec35b340681a",
                      "meta":{
                          "title":"详情",
                          "icon":null,
                          "code":"AchievementPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Create",
                      "name":"CreateAchievementPolicy",
                      "component":"views/content/data-set/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"fca58660-6fbd-40a4-8c67-bd5f9f8c5153",
                      "pid":"af4fd487-0352-4fa5-b811-ec35b340681a",
                      "meta":{
                          "title":"添加",
                          "icon":null,
                          "code":"AchievementPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Edit",
                      "name":"EditAchievementPolicy",
                      "component":"views/content/data-set/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"cfd4da5d-5b3e-444d-93f9-6804619c7051",
                      "pid":"af4fd487-0352-4fa5-b811-ec35b340681a",
                      "meta":{
                          "title":"修改",
                          "icon":null,
                          "code":"AchievementPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Delete",
                      "name":"DeleteAchievementPolicy",
                      "component":null,
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"bccf7ada-f8b2-4eef-b32e-ef8c34f06801",
                      "pid":"af4fd487-0352-4fa5-b811-ec35b340681a",
                      "meta":{
                          "title":"删除",
                          "icon":null,
                          "code":"AchievementPolicy",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          },
          {
              "path":"/Translate/SupportAndApply",
              "name":"SupportAndApply",
              "component":"Layout",
              "redirect":"",
              "alwaysShow":false,
              "hidden":false,
              "sort":3,
              "id":"0192c713-6549-4390-9517-16ad0439e1cd",
              "pid":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
              "meta":{
                  "title":"产业供需对接",
                  "icon":"iconconnections",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Translate/SupportAndApply/ProductSupply",
                      "name":"ProductSupply",
                      "component":"Layout",
                      "redirect":"/Translate/SupportAndApply/ProductSupply/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"ea047a1c-a163-400d-a51a-26784054f7fb",
                      "pid":"0192c713-6549-4390-9517-16ad0439e1cd",
                      "meta":{
                          "title":"供需产品",
                          "icon":"",
                          "code":"ProductSupply",
                          "portalIcon":"icongongxu",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListProductSupply",
                              "component":"pages/translate/product-supply/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"ef56d4c8-70a3-4208-b13c-75c6beef899d",
                              "pid":"ea047a1c-a163-400d-a51a-26784054f7fb",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"ProductSupply",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewProductSupply",
                              "component":"pages/translate/product-supply/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"85168715-a015-4070-8bf4-e5db4cf5727b",
                              "pid":"ea047a1c-a163-400d-a51a-26784054f7fb",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"ProductSupply",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateProductSupply",
                              "component":"pages/translate/product-supply/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"16163dc8-14a7-41e1-a656-b7048b0e4d6c",
                              "pid":"ea047a1c-a163-400d-a51a-26784054f7fb",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"ProductSupply",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditProductSupply",
                              "component":"pages/translate/product-supply/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"683ee9d2-9cd3-4474-b28f-ea6228180c7e",
                              "pid":"ea047a1c-a163-400d-a51a-26784054f7fb",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"ProductSupply",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteProductSupply",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"aedf147d-7b12-4d23-ba82-c352b9abbf7f",
                              "pid":"ea047a1c-a163-400d-a51a-26784054f7fb",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"ProductSupply",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Translate/SupportAndApply/PreferentialPolicies",
                      "name":"PreferentialPolicies",
                      "component":"Layout",
                      "redirect":"/Translate/SupportAndApply/PreferentialPolicies/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"049cad94-9186-4163-baa6-1acd275f6e65",
                      "pid":"0192c713-6549-4390-9517-16ad0439e1cd",
                      "meta":{
                          "title":"惠企政策",
                          "icon":"",
                          "code":"PreferentialPolicies",
                          "portalIcon":"iconzhengce",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListPreferentialPolicies",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"7e752575-eb60-4e25-9e7f-31a50b2c17f1",
                              "pid":"049cad94-9186-4163-baa6-1acd275f6e65",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"PreferentialPolicies",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewPreferentialPolicies",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"c1f323c7-ae6f-47c3-83bf-a05d7375bfbf",
                              "pid":"049cad94-9186-4163-baa6-1acd275f6e65",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"PreferentialPolicies",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreatePreferentialPolicies",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"cd1e0660-a2de-4749-8a03-7efc7ed7f92c",
                              "pid":"049cad94-9186-4163-baa6-1acd275f6e65",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"PreferentialPolicies",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditPreferentialPolicies",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"39ea9079-5269-4de6-a0c7-c5444c073414",
                              "pid":"049cad94-9186-4163-baa6-1acd275f6e65",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"PreferentialPolicies",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeletePreferentialPolicies",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"8d53638b-7c62-4d22-8301-6773d231be48",
                              "pid":"049cad94-9186-4163-baa6-1acd275f6e65",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"PreferentialPolicies",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Translate/Intermediary",
              "name":"Intermediary",
              "component":"Layout",
              "redirect":null,
              "alwaysShow":false,
              "hidden":false,
              "sort":4,
              "id":"b08fdfac-e5c4-4416-8e49-cf9be9828757",
              "pid":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
              "meta":{
                  "title":"支撑服务",
                  "icon":"iconRectangleCopy",
                  "code":"",
                  "portalIcon":null,
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"/Translate/Intermediary/Intermediary",
                      "name":"Intermediary",
                      "component":"Layout",
                      "redirect":"/Translate/Intermediary/Intermediary/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":1,
                      "id":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                      "pid":"b08fdfac-e5c4-4416-8e49-cf9be9828757",
                      "meta":{
                          "title":"科技中介",
                          "icon":"",
                          "code":"Intermediary",
                          "portalIcon":"iconkejizhongjie",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListIntermediary",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"9e06dad6-e1d4-4dbf-81d3-f9ef28922798",
                              "pid":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"Intermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewIntermediary",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"78b9901d-51aa-4bb5-9d7d-3062e6c4079d",
                              "pid":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"Intermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateIntermediary",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"f19e0d79-6074-4c59-ab88-1f51985588d0",
                              "pid":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"Intermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditIntermediary",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"ec01b500-38b3-4a42-96a9-b8672523def7",
                              "pid":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"Intermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteIntermediary",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"cf93e678-3cdb-4293-9609-ad877e0bf42b",
                              "pid":"df94ffff-24bb-441e-90ff-cc833cba7d3f",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"Intermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  },
                  {
                      "path":"/Translate/Intermediary/AchievementIntermediary",
                      "name":"AchievementIntermediary",
                      "component":"Layout",
                      "redirect":"/Translate/Intermediary/AchievementIntermediary/List",
                      "alwaysShow":false,
                      "hidden":false,
                      "sort":2,
                      "id":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                      "pid":"b08fdfac-e5c4-4416-8e49-cf9be9828757",
                      "meta":{
                          "title":"成果转化支撑服务库",
                          "icon":"",
                          "code":"AchievementIntermediary",
                          "portalIcon":"iconchengguozhuanhuazhichengfuwuku-big",
                          "roles":[

                          ]
                      },
                      "children":[
                          {
                              "path":"List",
                              "name":"ListAchievementIntermediary",
                              "component":"views/content/data-set/index",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":1,
                              "id":"aabc5066-61c6-45dd-a80a-09c21cec61bf",
                              "pid":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                              "meta":{
                                  "title":"列表",
                                  "icon":null,
                                  "code":"AchievementIntermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"View",
                              "name":"ViewAchievementIntermediary",
                              "component":"views/content/data-set/view",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":2,
                              "id":"c22d5781-6e0b-41c9-87a7-fa02cd624a0a",
                              "pid":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                              "meta":{
                                  "title":"详情",
                                  "icon":null,
                                  "code":"AchievementIntermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Create",
                              "name":"CreateAchievementIntermediary",
                              "component":"views/content/data-set/create",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":3,
                              "id":"ad8e8fd9-b906-44cf-b1ac-cc06aa0c7472",
                              "pid":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                              "meta":{
                                  "title":"添加",
                                  "icon":null,
                                  "code":"AchievementIntermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Edit",
                              "name":"EditAchievementIntermediary",
                              "component":"views/content/data-set/edit",
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":4,
                              "id":"fe7025ed-049f-421a-a47b-9199410af2d7",
                              "pid":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                              "meta":{
                                  "title":"修改",
                                  "icon":null,
                                  "code":"AchievementIntermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          },
                          {
                              "path":"Delete",
                              "name":"DeleteAchievementIntermediary",
                              "component":null,
                              "redirect":null,
                              "alwaysShow":false,
                              "hidden":true,
                              "sort":5,
                              "id":"39fd9908-0fe5-49e9-acc1-cd7a5c961c9e",
                              "pid":"1a98cb6f-27b8-4757-a93b-fecce1cdc3a7",
                              "meta":{
                                  "title":"删除",
                                  "icon":null,
                                  "code":"AchievementIntermediary",
                                  "portalIcon":null,
                                  "roles":[

                                  ]
                              },
                              "children":[

                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "path":"/Translate/ThirdpartApi",
              "name":"ThirdpartApi",
              "component":"Layout",
              "redirect":"/Translate/ThirdpartApi/List",
              "alwaysShow":false,
              "hidden":false,
              "sort":5,
              "id":"8160099e-fce2-47e3-b6a9-340254bb72e7",
              "pid":"a99091ae-9dc7-4bc6-8e2b-911c0d7d619c",
              "meta":{
                  "title":"产业信息对接",
                  "icon":"iconAPI",
                  "code":"ThirdpartApi",
                  "portalIcon":"iconAPI",
                  "roles":[

                  ]
              },
              "children":[
                  {
                      "path":"List",
                      "name":"ListThirdpartApi",
                      "component":"views/content/data-set/index",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":1,
                      "id":"ae3ec1f6-36a0-4993-81c0-92b60f7e7bbd",
                      "pid":"8160099e-fce2-47e3-b6a9-340254bb72e7",
                      "meta":{
                          "title":"列表",
                          "icon":null,
                          "code":"ThirdpartApi",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"View",
                      "name":"ViewThirdpartApi",
                      "component":"views/content/data-set/view",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":2,
                      "id":"07aac206-2a79-4ec9-bcb8-93151f1346ce",
                      "pid":"8160099e-fce2-47e3-b6a9-340254bb72e7",
                      "meta":{
                          "title":"详情",
                          "icon":null,
                          "code":"ThirdpartApi",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Create",
                      "name":"CreateThirdpartApi",
                      "component":"views/content/data-set/create",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":3,
                      "id":"af4c533a-2526-4669-bef0-664e8d8079aa",
                      "pid":"8160099e-fce2-47e3-b6a9-340254bb72e7",
                      "meta":{
                          "title":"添加",
                          "icon":null,
                          "code":"ThirdpartApi",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Edit",
                      "name":"EditThirdpartApi",
                      "component":"views/content/data-set/edit",
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":4,
                      "id":"9c6f2a9b-b608-4180-b3f2-a04de0c68be1",
                      "pid":"8160099e-fce2-47e3-b6a9-340254bb72e7",
                      "meta":{
                          "title":"修改",
                          "icon":null,
                          "code":"ThirdpartApi",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  },
                  {
                      "path":"Delete",
                      "name":"DeleteThirdpartApi",
                      "component":null,
                      "redirect":null,
                      "alwaysShow":false,
                      "hidden":true,
                      "sort":5,
                      "id":"5823e036-b81c-4503-9d25-45c14ac3d7eb",
                      "pid":"8160099e-fce2-47e3-b6a9-340254bb72e7",
                      "meta":{
                          "title":"删除",
                          "icon":null,
                          "code":"ThirdpartApi",
                          "portalIcon":null,
                          "roles":[

                          ]
                      },
                      "children":[

                      ]
                  }
              ]
          }
      ]
}];
let str = JSON.stringify(arr);
export default str;